(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2367],{

/***/ 36151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/country/[slug]",
      function () {
        return __webpack_require__(12299);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76604);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14523);





const Banner = ({ children , bannerData , bgInverted =false , bannerStyles ={} , imageWrapperStyles ={}  })=>{
    const isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(768);
    const bannerImageData = !isMobile ? bannerData?.priorityImage : bannerData?.priorityImageMobile;
    const { 0: aspectRatio , 1: setAspectRatio  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAspectRatio(null);
        const url = bannerImageData?.url;
        if (isMobile || !url) return;
        const img = new window.Image();
        const onLoad = ()=>{
            if (img.naturalWidth && img.naturalHeight) {
                setAspectRatio(img.naturalWidth / img.naturalHeight);
            }
        };
        img.addEventListener("load", onLoad);
        img.src = url;
        return ()=>img.removeEventListener("load", onLoad);
    }, [
        bannerImageData?.url,
        isMobile
    ]);
    const imageClickHandler = (url)=>()=>{
            window.open(url ?? "", "_blank");
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: bannerImageData?.url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["image-wrapper"]),
            style: {
                background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)",
                ...imageWrapperStyles
            },
            onClick: imageClickHandler(bannerData?.priorityImageUrl ?? ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["priority-image-container"]),
                style: !isMobile && aspectRatio ? {
                    aspectRatio: String(aspectRatio),
                    height: "auto"
                } : undefined,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: bannerImageData?.url ?? "/images/man_with_foldedhands.png",
                    alt: bannerData?.title ?? "banner-image",
                    layout: "fill",
                    objectFit: isMobile ? "fill" : "contain",
                    className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["priority-image"]),
                    priority: true,
                    isLazyLoad: false
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["banner-container-wrapper"]),
            style: {
                background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["banner-container"]),
                style: bannerStyles,
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82908);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78182);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40607);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70710);













const Testimonial = ({ title , bgColor , slug , data  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: testimonialData , 1: setTestimonialData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const { 0: centerSlide , 1: setCenterSlide  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const settings = {
        dotsClass: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sliderDots),
        dots: false,
        infinite: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        initialSlide: 1,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 200
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    dots: false
                }
            }
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        data ? setTestimonialData(data) : (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/${slug}`, "GET", {}, "", false).then((res)=>setTestimonialData(res));
    }, []);
    return testimonialData?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        id: "studenttestimonial",
        className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().studentTestSlider),
        style: {
            backgroundColor: bgColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-5 text-center",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "studentmm",
                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().student),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    ref: sliderRef,
                                    className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider)}`,
                                    children: testimonialData.map((slide, ind)=>{
                                        return ind < 15 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stuTestCard)}`,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardBody),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "33",
                                                            height: "22",
                                                            viewBox: "0 0 33 22",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                                    fill: "#226CF5"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                                    fill: "#226CF5"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "my-4",
                                                            children: slide?.testimonial?.message
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                            className: "mb-0",
                                                            children: slide?.testimonial?.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().addre),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.details
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.subDetails
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, ind);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrowsClass),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickPrev(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/left-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickNext(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/right-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "right-arrow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Testimonial);


/***/ }),

/***/ 72767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Chevron = ({ width =13 , height =21 , color ="#0B0C2D"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 13 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 19L11.5 10.6667L1.5 1.5",
            stroke: color,
            "stroke-width": "3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chevron);


/***/ }),

/***/ 30535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const CrossIcon = ({ width =20 , height =20 , color ="#868697"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 0.999939L1 12.9999M1 0.999939L13 12.9999",
            stroke: color,
            strokeWidth: "1.99991",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CrossIcon);


/***/ }),

/***/ 67316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const DollarEnclosed = ({ width =20 , height =20 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.50175 19C8.18775 19 6.95267 18.7507 5.7965 18.252C4.64033 17.7533 3.63467 17.0766 2.7795 16.2218C1.92433 15.3669 1.24725 14.3617 0.74825 13.206C0.249417 12.0503 0 10.8156 0 9.50175C0 8.18775 0.249333 6.95267 0.748 5.7965C1.24667 4.64033 1.92342 3.63467 2.77825 2.7795C3.63308 1.92433 4.63833 1.24725 5.794 0.74825C6.94967 0.249417 8.18442 0 9.49825 0C10.8123 0 12.0473 0.249333 13.2035 0.748C14.3597 1.24667 15.3653 1.92342 16.2205 2.77825C17.0757 3.63308 17.7528 4.63833 18.2518 5.794C18.7506 6.94967 19 8.18442 19 9.49825C19 10.8123 18.7507 12.0473 18.252 13.2035C17.7533 14.3597 17.0766 15.3653 16.2218 16.2205C15.3669 17.0757 14.3617 17.7528 13.206 18.2518C12.0503 18.7506 10.8156 19 9.50175 19ZM9.5 17.5C11.7333 17.5 13.625 16.725 15.175 15.175C16.725 13.625 17.5 11.7333 17.5 9.5C17.5 7.26667 16.725 5.375 15.175 3.825C13.625 2.275 11.7333 1.5 9.5 1.5C7.26667 1.5 5.375 2.275 3.825 3.825C2.275 5.375 1.5 7.26667 1.5 9.5C1.5 11.7333 2.275 13.625 3.825 15.175C5.375 16.725 7.26667 17.5 9.5 17.5ZM9.95275 16.1028C10.0894 15.9663 10.1578 15.807 10.1578 15.625V15.0962C10.9334 14.9911 11.6357 14.6997 12.2645 14.222C12.8933 13.7445 13.2078 13.0205 13.2078 12.05C13.2078 11.35 13.0013 10.7308 12.5885 10.1923C12.1757 9.65392 11.3692 9.16808 10.1692 8.73475C9.11792 8.37575 8.41983 8.06483 8.075 7.802C7.73017 7.53917 7.55775 7.17183 7.55775 6.7C7.55775 6.22817 7.73433 5.84483 8.0875 5.55C8.44067 5.25517 8.92817 5.10775 9.55 5.10775C9.92183 5.10775 10.2472 5.17725 10.526 5.31625C10.8048 5.45542 11.0404 5.641 11.2327 5.873C11.3546 6.02183 11.4956 6.12567 11.6557 6.1845C11.8161 6.2435 11.9678 6.241 12.111 6.177C12.3065 6.1 12.4401 5.96858 12.5117 5.78275C12.5834 5.59675 12.5654 5.42625 12.4578 5.27125C12.1911 4.89425 11.8603 4.58042 11.4653 4.32975C11.0704 4.07908 10.6512 3.93708 10.2078 3.90375V3.375C10.2078 3.193 10.1394 3.03375 10.0027 2.89725C9.86625 2.76058 9.707 2.69225 9.525 2.69225C9.343 2.69225 9.18375 2.76058 9.04725 2.89725C8.91058 3.03375 8.84225 3.193 8.84225 3.375V3.90375C7.98975 4.06792 7.335 4.41375 6.878 4.94125C6.42083 5.46892 6.19225 6.05517 6.19225 6.7C6.19225 7.45133 6.41983 8.05583 6.875 8.5135C7.33017 8.97117 8.07183 9.38458 9.1 9.75375C10.1628 10.1436 10.8888 10.4933 11.278 10.803C11.667 11.1125 11.8615 11.5282 11.8615 12.05C11.8615 12.677 11.6353 13.1324 11.1827 13.4163C10.7301 13.7003 10.2192 13.8422 9.65 13.8422C9.175 13.8422 8.74567 13.7237 8.362 13.4865C7.97833 13.2493 7.657 12.9064 7.398 12.4578C7.29683 12.2821 7.16033 12.1638 6.9885 12.103C6.81667 12.042 6.6485 12.0439 6.484 12.1088C6.30667 12.1736 6.17683 12.2967 6.0945 12.478C6.01233 12.6593 6.01158 12.8327 6.09225 12.998C6.37175 13.5583 6.7365 14.0064 7.1865 14.3422C7.6365 14.6783 8.17175 14.9129 8.79225 15.0462V15.625C8.79225 15.807 8.86058 15.9663 8.99725 16.1028C9.13375 16.2394 9.293 16.3078 9.475 16.3078C9.657 16.3078 9.81625 16.2394 9.95275 16.1028Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DollarEnclosed);


/***/ }),

/***/ 31331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const FeatherNote = ({ width =20 , height =20 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 19 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.87494 14.846C5.46244 14.846 5.10928 14.6992 4.81544 14.4055C4.52178 14.1117 4.37494 13.7585 4.37494 13.346V11.75C4.37494 11.4938 4.46153 11.2792 4.63469 11.106C4.80803 10.9328 5.02269 10.8463 5.27869 10.8463H7.25944V8.096C6.73378 8.13333 6.19628 8.0805 5.64694 7.9375C5.09761 7.7945 4.62036 7.54158 4.21519 7.17875C4.12119 7.08792 4.04669 6.98575 3.99169 6.87225C3.93686 6.75875 3.90944 6.6385 3.90944 6.5115V5.65375H3.00169C2.88403 5.65375 2.77003 5.632 2.65969 5.5885C2.54936 5.54483 2.44769 5.47658 2.35469 5.38375L0.264944 3.294C0.079277 3.10817 -0.00880636 2.89158 0.000693638 2.64425C0.0103603 2.39675 0.112027 2.18583 0.305694 2.0115C0.789027 1.59867 1.39094 1.29417 2.11144 1.098C2.83194 0.901834 3.51461 0.803751 4.15944 0.803751C4.70494 0.803751 5.23519 0.866 5.75019 0.9905C6.26536 1.11483 6.76844 1.31992 7.25944 1.60575V1.423C7.25944 1.02633 7.39744 0.69 7.67344 0.414C7.94944 0.138 8.28578 0 8.68244 0H16.4562C16.9519 0 17.3764 0.177001 17.7297 0.531001C18.0829 0.885001 18.2594 1.31058 18.2594 1.80775V12.346C18.2594 13.0448 18.0174 13.6362 17.5334 14.12C17.0494 14.604 16.4581 14.846 15.7594 14.846H5.87494ZM8.75944 10.8463H13.8749C14.1198 10.8463 14.3284 10.9324 14.5007 11.1048C14.6732 11.2773 14.7594 11.4859 14.7594 11.7308V12.346C14.7594 12.6293 14.8553 12.8668 15.0469 13.0585C15.2386 13.2502 15.4761 13.346 15.7594 13.346C16.0428 13.346 16.2803 13.2502 16.4719 13.0585C16.6636 12.8668 16.7594 12.6293 16.7594 12.346V1.80775C16.7594 1.71792 16.7306 1.64417 16.6729 1.5865C16.6153 1.52883 16.5415 1.5 16.4517 1.5H9.06719C8.97736 1.5 8.90361 1.52883 8.84594 1.5865C8.78828 1.64417 8.75944 1.71792 8.75944 1.80775V2.6L14.3017 8.14225C14.4162 8.25442 14.4862 8.38217 14.5117 8.5255C14.537 8.66867 14.5184 8.80975 14.4557 8.94875C14.3929 9.08792 14.3049 9.1985 14.1917 9.2805C14.0787 9.36267 13.9342 9.40375 13.7582 9.40375C13.6577 9.40375 13.5606 9.38208 13.4669 9.33875C13.3731 9.29542 13.2949 9.24275 13.2324 9.18075L10.5094 6.45775L10.1267 6.84025C9.91269 7.05442 9.69411 7.24033 9.47094 7.398C9.24794 7.55567 9.01078 7.6845 8.75944 7.7845V10.8463ZM3.26319 4.15375H4.50569C4.76169 4.15375 4.97636 4.24042 5.14969 4.41375C5.32286 4.58692 5.40944 4.80158 5.40944 5.05775V6.20775C5.67994 6.37958 5.94278 6.49683 6.19794 6.5595C6.45311 6.62233 6.70828 6.65375 6.96344 6.65375C7.38261 6.65375 7.76236 6.58583 8.10269 6.45C8.44303 6.31417 8.76961 6.08983 9.08244 5.777L9.45569 5.40375L7.88244 3.83075C7.37344 3.32175 6.80294 2.94 6.17094 2.6855C5.53894 2.431 4.86844 2.30375 4.15944 2.30375C3.74911 2.30375 3.35394 2.348 2.97394 2.4365C2.59378 2.525 2.23761 2.64492 1.90544 2.79625L3.26319 4.15375ZM13.2594 12.346H5.87494V13.346H13.4864C13.4044 13.2025 13.3461 13.0463 13.3114 12.8775C13.2768 12.7088 13.2594 12.5317 13.2594 12.346Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatherNote);


/***/ }),

/***/ 98188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20829);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Icons_CrossIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30535);





const Modal = ({ children , onClose , isOpen , contentClassName  })=>{
    const { 0: mounted , 1: setMounted  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
        return ()=>setMounted(false);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isOpen) return;
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = originalOverflow;
        };
    }, [
        isOpen
    ]);
    if (!isOpen || !mounted) return null;
    const handleBackdropClick = (e)=>{
        e.stopPropagation();
        onClose();
    };
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().backdrop),
        onClick: handleBackdropClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: contentClassName ?? (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["modal-container"]),
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["close-button-container"]),
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["close-button"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons_CrossIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            width: 12,
                            height: 12
                        })
                    })
                }),
                children
            ]
        })
    }), document.body);
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 63098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28154);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Spinner = ({ width =40 , height =40  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().spinner),
        style: {
            width,
            height
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 14523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useIsMobile.ts

const useIsMobile = (breakpoint = 768)=>{
    const { 0: isMobile , 1: setIsMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleChange = (e)=>{
            setIsMobile(e.matches);
        };
        // Set initial value
        setIsMobile(mediaQuery.matches);
        // Listen for changes
        mediaQuery.addEventListener("change", handleChange);
        return ()=>{
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, [
        breakpoint
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 12299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ErrorComponent.tsx
var ErrorComponent = __webpack_require__(46412);
// EXTERNAL MODULE: ./components/UI/SecondaryNav/SecondaryNav.module.scss
var SecondaryNav_module = __webpack_require__(49273);
var SecondaryNav_module_default = /*#__PURE__*/__webpack_require__.n(SecondaryNav_module);
// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
// EXTERNAL MODULE: ./components/UI/Icons/Chevron.tsx
var Chevron = __webpack_require__(72767);
// EXTERNAL MODULE: ./components/UI/Modal/Modal.tsx
var Modal = __webpack_require__(98188);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./components/UI/SecondaryNav/SecondaryNav.tsx







const slugify = (value)=>value.trim().toLowerCase().replace(/\s+/g, "-");
const SecondaryNav = ({ items =constants/* COUNTRY_DETAIL_SECONDARY_NAV_ITEMS */.Tq , onSelectTab , headerHeight  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(1000);
    const { 0: activeTab , 1: setActiveTab  } = (0,react.useState)("why");
    const { 0: isMenuOpen , 1: setIsMenuOpen  } = (0,react.useState)(false);
    const isClickScrolling = (0,react.useRef)(false);
    const clickScrollTimeout = (0,react.useRef)(null);
    // Ensures the on-reload scroll restore only fires once.
    const didRestore = (0,react.useRef)(false);
    const scrollToSection = (tab, behavior = "smooth")=>{
        setActiveTab(tab);
        onSelectTab?.(tab);
        const sectionId = slugify(tab);
        const section = document.getElementById(sectionId);
        if (section) {
            const url = new URL(window.location.href);
            url.hash = sectionId;
            window.history.replaceState(null, "", url);
            const offset = (headerHeight ?? 0) + 54;
            const top = section.getBoundingClientRect().top + window.scrollY - offset;
            isClickScrolling.current = true;
            if (clickScrollTimeout.current) clearTimeout(clickScrollTimeout.current);
            clickScrollTimeout.current = setTimeout(()=>{
                isClickScrolling.current = false;
            }, 800);
            window.scrollTo({
                top,
                behavior
            });
        }
    };
    const handleTabClick = (tab)=>()=>scrollToSection(tab, "smooth");
    // Scroll spy: highlight the tab whose section is currently under the nav.
    (0,react.useEffect)(()=>{
        if (items?.length === 0) return;
        const offset = (headerHeight ?? 0) + 54;
        const sections = items?.map((item)=>document.getElementById(slugify(item?.id ?? ""))).filter((el)=>el !== null);
        if (sections?.length === 0) return;
        const observer = new IntersectionObserver((entries)=>{
            if (isClickScrolling.current) return;
            const visible = entries.filter((entry)=>entry.isIntersecting).sort((a, b)=>a.boundingClientRect.top - b.boundingClientRect.top);
            if (visible.length === 0) return;
            const matched = items.find((item)=>slugify(item.id) === visible[0].target.id);
            if (matched) {
                setActiveTab(matched.id);
                onSelectTab?.(matched.id);
            }
        }, {
            rootMargin: `-${offset}px 0px -55% 0px`,
            threshold: 0
        });
        sections?.forEach((section)=>observer.observe(section));
        return ()=>observer.disconnect();
    }, [
        items,
        headerHeight,
        onSelectTab
    ]);
    (0,react.useEffect)(()=>{
        return ()=>{
            if (clickScrollTimeout.current) clearTimeout(clickScrollTimeout.current);
        };
    }, []);
    const menuClickHandler = ()=>{
        setIsMenuOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                top: `${headerHeight}px`
            },
            className: `${(SecondaryNav_module_default()).secondaryNavContainer} ${isMobile ? (SecondaryNav_module_default())["hide-scrollbar"] : ""}`,
            children: items && items.length > 0 && items.map((navItem)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `${(SecondaryNav_module_default()).secondaryNavItem} ${activeTab === navItem.id ? (SecondaryNav_module_default()).secondaryNavItemActive : ""}`,
                    onClick: handleTabClick(navItem.id),
                    children: [
                        navItem.title,
                        activeTab === navItem.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SecondaryNav_module_default()).activeIndicator
                        })
                    ]
                }, navItem.id))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                top: `${headerHeight}px`
            },
            className: (SecondaryNav_module_default())["secondary-menu"],
            onClick: menuClickHandler,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SecondaryNav_module_default())["secondary-menu-item"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: items.find((item)=>item.id === activeTab)?.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            width: 8,
                            height: 14,
                            color: "#0E1B2C"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    isOpen: isMenuOpen,
                    onClose: ()=>{
                        setIsMenuOpen(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SecondaryNav_module_default())["modal-content"],
                        children: items && items.length > 0 && items.map((navItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(SecondaryNav_module_default())["modal-content-item"]} ${activeTab === navItem.id ? (SecondaryNav_module_default()).modalContentItemActive : ""}`,
                                onClick: ()=>{
                                    setIsMenuOpen(false);
                                    handleTabClick(navItem.id)();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: navItem.title
                                })
                            }, navItem.id))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SecondaryNav_SecondaryNav = (SecondaryNav);

// EXTERNAL MODULE: ./components/CountryDetail/Universities/Universities.module.scss
var Universities_module = __webpack_require__(49899);
var Universities_module_default = /*#__PURE__*/__webpack_require__.n(Universities_module);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js + 2 modules
var embla_carousel_react_esm = __webpack_require__(89382);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var b2c_constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./components/CountryDetail/Universities/Universities.tsx














const Universities = ({ countryData  })=>{
    const router = (0,next_router.useRouter)();
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const [emblaRef, emblaApi] = (0,embla_carousel_react_esm/* default */.Z)({
        loop: true,
        align: "start"
    });
    const { 0: topUniversities , 1: setTopUniversities  } = (0,react.useState)([]);
    const { 0: canScrollPrev , 1: setCanScrollPrev  } = (0,react.useState)(false);
    const { 0: canScrollNext , 1: setCanScrollNext  } = (0,react.useState)(false);
    const countrySlug = countryData?.name === "UK" ? "uk" : (0,helpers/* getSlugFromCountry */.TX)(countryData?.name, constants/* countries */.hW);
    const goToPrev = ()=>emblaApi?.scrollPrev();
    const goToNext = ()=>emblaApi?.scrollNext();
    (0,react.useEffect)(()=>{
        if (countryData?.name) {
            const countryName = countryData?.name === "UnitedKingdom" ? "UK" : countryData?.name;
            (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/universities?country=${countryName.replace(/ /g, "")}&_start=0&_limit=10&_sort=priority:ASC`, "GET", {}, "", false).then((res)=>setTopUniversities(res));
        }
    }, [
        countryData
    ]);
    (0,react.useEffect)(()=>{
        if (emblaApi && topUniversities.length > 0) {
            emblaApi.reInit();
        }
    }, [
        topUniversities,
        emblaApi
    ]);
    (0,react.useEffect)(()=>{
        if (!emblaApi) return;
        const onSelect = ()=>{
            setCanScrollPrev(emblaApi.canScrollPrev());
            setCanScrollNext(emblaApi.canScrollNext());
        };
        onSelect();
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
        return ()=>{
            emblaApi.off("select", onSelect);
            emblaApi.off("reInit", onSelect);
        };
    }, [
        emblaApi,
        topUniversities
    ]);
    const applyClickHandler = (applyNowButtonProps, receivedData)=>(e)=>{
            if (applyNowButtonProps?.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: receivedData?.nearestOffice ?? true,
                    coachingVisible: receivedData?.lookingForCoaching ?? true
                });
            }
            applyNowButtonProps?.onClick?.(e);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "universities",
        className: (Universities_module_default())["universities-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Universities_module_default())["universities-title"],
                children: countryData?.topUniversities?.title ?? ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Universities_module_default())["universities-description"],
                dangerouslySetInnerHTML: {
                    __html: countryData?.topUniversities?.description ?? ""
                }
            }),
            isMobile ? // Mobile View
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(Universities_module_default())["uni-cards-container"]} ${(Universities_module_default())["uni-cards-container-mobile"]}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Universities_module_default()).viewport,
                        ref: emblaRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Universities_module_default())["uni-cards-slider-container"],
                            children: topUniversities.map((university)=>{
                                const slug = university.slug;
                                const url = slug && university.country ? `/universities/${(0,helpers/* getSlugFromCountryUniDetail */.gX)(university.country, constants/* unicountries */.SS)}/${slug}` : "";
                                const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
                                    btnLink: university?.studyDestinationCard?.button2?.link,
                                    formId: university?.studyDestinationCard?.button2?.formId,
                                    toOnboardingEnabled: university?.studyDestinationCard?.button2?.toOnboardingEnabled,
                                    sourceUrl:  true ? window.location.pathname : 0
                                });
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Universities_module_default()).slide,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                        className: (Universities_module_default())["bootstrap-card-mobile"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Universities_module_default()).cardImageWrap,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: university.universityLogo?.imageUrl || "/images/university-detail-gallery/university-dummy-logo.jpg",
                                                    alt: university.name,
                                                    layout: "responsive",
                                                    width: 240,
                                                    height: 80
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Universities_module_default()).separator
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Universities_module_default())["card-content"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: university.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (Universities_module_default())["address-text"],
                                                        children: university.location
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (Universities_module_default())["visit-website-link"],
                                                        children: university.universityUrl
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Universities_module_default())["card-btn-container"],
                                                children: [
                                                    slug && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: ()=>window.open(url, "_blank"),
                                                        className: (Universities_module_default())["know-more-btn"],
                                                        children: "Know More"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: `${(Universities_module_default())["apply-now-btn"]} ${applyCtaButtonProps.formClassName}`,
                                                        onClick: applyClickHandler(applyCtaButtonProps, university?.studyDestinationCard?.button2),
                                                        children: university?.studyDestinationCard?.button2?.title ?? "Apply Now"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, university.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Universities_module_default())["arrows-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Universities_module_default()).btcircle} ${!canScrollPrev ? (Universities_module_default())["btcircle-disabled"] : ""}`,
                                onClick: goToPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Universities_module_default()).btcircle} ${!canScrollNext ? (Universities_module_default())["btcircle-disabled"] : ""}`,
                                onClick: goToNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "right-arrow"
                                })
                            })
                        ]
                    })
                ]
            }) : // Desktop View
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Universities_module_default())["uni-cards-container"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Universities_module_default()).viewport,
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Universities_module_default())["uni-cards-slider-container"],
                                children: topUniversities.map((university)=>{
                                    const slug = university.slug;
                                    const url = slug && university.country ? `/universities/${(0,helpers/* getSlugFromCountryUniDetail */.gX)(university.country, constants/* unicountries */.SS)}/${slug}` : "";
                                    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
                                        btnLink: university?.studyDestinationCard?.button2?.link,
                                        formId: university?.studyDestinationCard?.button2?.formId,
                                        toOnboardingEnabled: university?.studyDestinationCard?.button2?.toOnboardingEnabled,
                                        sourceUrl:  true ? window.location.pathname : 0
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Universities_module_default()).slide,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                            className: (Universities_module_default())["bootstrap-card"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Universities_module_default()).cardImageWrap,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: university.universityLogo?.imageUrl || "/images/university-detail-gallery/university-dummy-logo.jpg",
                                                        alt: university.name,
                                                        layout: "responsive",
                                                        width: 240,
                                                        height: 80
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Universities_module_default()).separator
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Universities_module_default())["card-content"],
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: university.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (Universities_module_default())["address-text"],
                                                            children: university.location
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (Universities_module_default())["visit-website-link"],
                                                            children: university.universityUrl
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Universities_module_default())["card-btn-container"],
                                                    children: [
                                                        slug && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            onClick: ()=>window.open(url, "_blank"),
                                                            className: (Universities_module_default())["know-more-btn"],
                                                            children: "Know More"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: `${(Universities_module_default())["apply-now-btn"]} ${applyCtaButtonProps.formClassName}`,
                                                            onClick: applyClickHandler(applyCtaButtonProps, university?.studyDestinationCard?.button2),
                                                            children: university?.studyDestinationCard?.button2?.title ?? "Apply Now"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, university.id);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Universities_module_default())["arrows-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Universities_module_default()).btcircle} ${!canScrollPrev ? (Universities_module_default())["btcircle-disabled"] : ""}`,
                                onClick: goToPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Universities_module_default()).btcircle} ${!canScrollNext ? (Universities_module_default())["btcircle-disabled"] : ""}`,
                                onClick: goToNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "right-arrow"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: ()=>window.open(`/universities/${countrySlug}`, "_blank"),
                className: (Universities_module_default())["view-more-universities-btn"],
                children: "View More Universities"
            })
        ]
    });
};
/* harmony default export */ var Universities_Universities = (Universities);

// EXTERNAL MODULE: ./components/CountryDetail/CountryDetail.module.scss
var CountryDetail_module = __webpack_require__(51147);
var CountryDetail_module_default = /*#__PURE__*/__webpack_require__.n(CountryDetail_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CountryDetail/HeroSection/HeroSection.module.scss
var HeroSection_module = __webpack_require__(16182);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
;// CONCATENATED MODULE: ./components/CountryDetail/HeroSection/HeroSection.tsx








const HeroSection = ({ countryData , headerHeight , setHeaderHeight  })=>{
    const router = (0,next_router.useRouter)();
    const herosectionData = countryData?.heroSection ?? {};
    (0,react.useEffect)(()=>{
        const header = document.getElementById("header-navbar");
        if (!header) return;
        const win = window;
        const measure = ()=>{
            setHeaderHeight(header.getBoundingClientRect().height);
        };
        measure();
        const ResizeObserverCtor = globalThis.ResizeObserver;
        if (typeof ResizeObserverCtor === "function") {
            const ro = new ResizeObserverCtor(measure);
            ro.observe(header);
            win.addEventListener("resize", measure);
            return ()=>{
                ro.disconnect();
                win.removeEventListener("resize", measure);
            };
        }
        win.addEventListener("resize", measure);
        return ()=>{
            win.removeEventListener("resize", measure);
        };
    }, []);
    const heroToOnboardingEnabled = herosectionData?.button?.toOnboardingEnabled;
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: herosectionData?.button?.link,
        formId: herosectionData?.button?.formId || (heroToOnboardingEnabled ? undefined : "main-enquiry-form"),
        toOnboardingEnabled: heroToOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: herosectionData?.button?.nearestOffice ?? true,
                    coachingVisible: herosectionData?.button?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            height: `calc(720px - ${headerHeight}px)`
        },
        className: (HeroSection_module_default())["hero-section-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                className: (HeroSection_module_default())["picture-bridge"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        media: "(max-width: 767px)",
                        srcSet: herosectionData?.heroImgLink ?? "/images/golden_gate_bridge.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: herosectionData?.heroImgLink ?? "/images/golden_gate_bridge.jpg",
                        loading: "eager",
                        fetchPriority: "high",
                        decoding: "async",
                        width: "100%",
                        height: "100%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HeroSection_module_default())["text-content-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                        className: (HeroSection_module_default())["breadcrumb-custom"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                className: (HeroSection_module_default())["breadcrumb-item-1"],
                                href: "/study-destinations",
                                children: "Study Destination"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                href: "",
                                className: (HeroSection_module_default())["breadcrumb-item-2"],
                                children: countryData?.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default())["hero-section-title"],
                        dangerouslySetInnerHTML: {
                            __html: herosectionData?.title ?? ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ctaBtnClickHandler(applyCtaButtonProps),
                        className: applyCtaButtonProps.formClassName,
                        children: herosectionData?.button?.title || "Enquire Now"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HeroSection_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./components/CountryDetail/Overview/Overview.module.scss
var Overview_module = __webpack_require__(18318);
var Overview_module_default = /*#__PURE__*/__webpack_require__.n(Overview_module);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
;// CONCATENATED MODULE: ./components/CountryDetail/Overview/Overview.tsx









const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
};
const Overview = ({ countryData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const sliderRef = (0,react.useRef)(null);
    const overviewData = countryData.overview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "why",
        className: (Overview_module_default())["overview-section-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Overview_module_default())["overview-title"],
                children: overviewData?.title ?? "Overview"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Overview_module_default())["overview-desc"],
                dangerouslySetInnerHTML: {
                    __html: overviewData?.description ?? ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Overview_module_default())["overview-cards-container"],
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Overview_module_default())["overview-mobile-slider"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            ...sliderSettings,
                            ref: sliderRef,
                            children: overviewData?.overviewCard?.length > 0 && overviewData?.overviewCard?.map((card, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                        className: (Overview_module_default())["bootstrap-card"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Overview_module_default())["icon-container"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: card.image?.url ?? "/icons/default-icon.svg",
                                                    height: 72,
                                                    width: 72,
                                                    alt: "icon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (Overview_module_default())["card-info"],
                                                children: card.description ?? ""
                                            })
                                        ]
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Overview_module_default())["arrows-container"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Overview_module_default()).btcircle,
                                    onClick: ()=>sliderRef?.current?.slickPrev(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/left-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Overview_module_default()).btcircle,
                                    onClick: ()=>sliderRef?.current?.slickNext(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/right-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "right-arrow"
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Overview_module_default())["overview-grid-layout"],
                    children: overviewData?.overviewCard?.length > 0 && overviewData?.overviewCard?.map((card, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                            className: (Overview_module_default())["bootstrap-card"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Overview_module_default())["icon-container"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: card.image?.url ?? "/icons/default-icon.svg",
                                        height: 72,
                                        width: 72,
                                        alt: "icon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Overview_module_default())["card-info"],
                                    children: card.description ?? ""
                                })
                            ]
                        }, index))
                })
            })
        ]
    });
};
/* harmony default export */ var Overview_Overview = (Overview);

// EXTERNAL MODULE: ./components/CountryDetail/Courses/Courses.module.scss
var Courses_module = __webpack_require__(72211);
var Courses_module_default = /*#__PURE__*/__webpack_require__.n(Courses_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Courses/Courses.tsx






const COLUMNS = 2;
const ROWS = 4;
const COLUMNS_FOR_MOBILE = 1;
const ROWS_FOR_MOBILE = 5;
function chunkCourses(arr, size) {
    const chunks = [];
    for(let i = 0; i < arr.length; i += size){
        chunks.push(arr.slice(i, i + size));
    }
    return chunks;
}
function getPopularCoursesLists(countryData, tabActive) {
    const top = countryData?.topCourses?.tabs ?? [];
    const rootTopCourses = top?.find((tab)=>tab?.title === tabActive)?.courses;
    return Array.isArray(rootTopCourses) && rootTopCourses.length > 0 ? rootTopCourses : [];
}
const Courses = ({ countryData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const [emblaRef, emblaApi] = (0,embla_carousel_react_esm/* default */.Z)({
        loop: false
    });
    const { 0: coursesData , 1: setCoursesData  } = (0,react.useState)([]);
    const { 0: tabActive , 1: setTabActive  } = (0,react.useState)(countryData?.topCourses?.tabs?.[0]?.title ?? "");
    const { 0: tabsArr , 1: setTabsArr  } = (0,react.useState)([]);
    const { 0: canScrollPrev , 1: setCanScrollPrev  } = (0,react.useState)(false);
    const { 0: canScrollNext , 1: setCanScrollNext  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const popularCoursesData = getPopularCoursesLists(countryData, tabActive);
        const courseSlides = chunkCourses(popularCoursesData, isMobile ? COLUMNS_FOR_MOBILE * ROWS_FOR_MOBILE : COLUMNS * ROWS);
        setCoursesData(courseSlides ?? []);
        setTabsArr(countryData?.topCourses?.tabs ?? []);
    }, [
        countryData,
        tabActive,
        isMobile
    ]);
    (0,react.useEffect)(()=>{
        if (!emblaApi) return;
        const updateScrollState = ()=>{
            setCanScrollPrev(emblaApi.canScrollPrev());
            setCanScrollNext(emblaApi.canScrollNext());
        };
        updateScrollState();
        emblaApi.on("select", updateScrollState);
        emblaApi.on("reInit", updateScrollState);
        return ()=>{
            emblaApi.off("select", updateScrollState);
            emblaApi.off("reInit", updateScrollState);
        };
    }, [
        emblaApi,
        coursesData
    ]);
    const goToPrev = ()=>emblaApi?.scrollPrev();
    const goToNext = ()=>emblaApi?.scrollNext();
    const filterClickHandler = (filter)=>{
        setTabActive(filter);
        emblaApi?.scrollTo(0);
    };
    const hasPriorityBanner = Boolean(countryData?.banner_1?.priorityImage?.url);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "courses",
        className: `${(Courses_module_default())["courses-container"]}${hasPriorityBanner ? ` ${(Courses_module_default())["courses-container--priority-banner"]}` : ""}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Courses_module_default())["courses-title"],
                children: countryData?.topCourses?.title ?? ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Courses_module_default())["courses-description"],
                dangerouslySetInnerHTML: {
                    __html: countryData?.topCourses?.description ?? ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Courses_module_default())["section-btn-container"],
                children: tabsArr?.length > 0 && tabsArr?.map((tab)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: tabActive === tab?.title ? `${(Courses_module_default())["bachelors-btn"]} ${(Courses_module_default())["active-btn"]}` : `${(Courses_module_default())["bachelors-btn"]}`,
                        onClick: ()=>filterClickHandler(tab?.title),
                        children: tab?.title
                    }, tab?.id))
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Courses_module_default())["courses-card-container-mobile"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Courses_module_default()).viewport,
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Courses_module_default())["courses-card-slider-container"],
                                children: coursesData.map((chunk, slideIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Courses_module_default()).courseSlide,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Courses_module_default()).courseGrid,
                                            children: chunk.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Courses_module_default()).courseCard,
                                                    children: el ?? ""
                                                }, index))
                                        })
                                    }, `slide-${slideIndex}`))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Courses_module_default())["arrows-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Courses_module_default()).btcircle}${canScrollPrev ? "" : ` ${(Courses_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollPrev ? goToPrev : undefined,
                                "aria-disabled": !canScrollPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Courses_module_default()).btcircle}${canScrollNext ? "" : ` ${(Courses_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollNext ? goToNext : undefined,
                                "aria-disabled": !canScrollNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "right-arrow"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Courses_module_default())["courses-card-container"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Courses_module_default()).viewport,
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Courses_module_default())["courses-card-slider-container"],
                                children: coursesData.map((chunk, slideIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Courses_module_default()).courseSlide,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Courses_module_default()).courseGrid,
                                            children: chunk.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Courses_module_default()).courseCard,
                                                    children: el ?? ""
                                                }, index))
                                        })
                                    }, `slide-${slideIndex}`))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Courses_module_default())["arrows-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Courses_module_default()).btcircle}${canScrollPrev ? "" : ` ${(Courses_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollPrev ? goToPrev : undefined,
                                "aria-disabled": !canScrollPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Courses_module_default()).btcircle}${canScrollNext ? "" : ` ${(Courses_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollNext ? goToNext : undefined,
                                "aria-disabled": !canScrollNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "right-arrow"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Courses_Courses = (Courses);

// EXTERNAL MODULE: ./components/CountryDetail/CostToStudy/CostToStudy.module.scss
var CostToStudy_module = __webpack_require__(21263);
var CostToStudy_module_default = /*#__PURE__*/__webpack_require__.n(CostToStudy_module);
;// CONCATENATED MODULE: ./components/CountryDetail/CostToStudy/CostToStudy.tsx




const CostToStudy = ({ countryData  })=>{
    const { 0: activeTab , 1: setActiveTab  } = (0,react.useState)("cost-of-study");
    const { 0: cardsArr , 1: setCardsArr  } = (0,react.useState)([]);
    const costToStudySectionData = countryData?.costToStudySection;
    (0,react.useEffect)(()=>{
        let tempCardsArr = activeTab === "cost-of-study" ? costToStudySectionData?.costOfEducation ?? [] : costToStudySectionData?.costOfLiving ?? [];
        setCardsArr(tempCardsArr ?? []);
    }, [
        costToStudySectionData,
        activeTab
    ]);
    const handleTabClick = (tab)=>{
        setActiveTab(tab);
    };
    const hasPriorityBanner = Boolean(countryData?.banner_1?.priorityImage?.url);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "cost",
        className: `${(CostToStudy_module_default())["cost-to-study-container"]}${hasPriorityBanner ? ` ${(CostToStudy_module_default())["cost-to-study-container--priority-banner"]}` : ""}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CostToStudy_module_default())["cost-card"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (CostToStudy_module_default())["cost-card-title"],
                    children: costToStudySectionData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CostToStudy_module_default())["cost-card-description"],
                    dangerouslySetInnerHTML: {
                        __html: costToStudySectionData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CostToStudy_module_default())["cost-card-features"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CostToStudy_module_default())["tab-container"],
                            children: [
                                costToStudySectionData?.costOfEducation?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: `${(CostToStudy_module_default())["study-tab-button"]} ${activeTab === "cost-of-study" && (CostToStudy_module_default())["active-tab"]}`,
                                    onClick: ()=>handleTabClick("cost-of-study"),
                                    children: "Cost of Study"
                                }),
                                costToStudySectionData?.costOfLiving?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: `${(CostToStudy_module_default())["living-tab-button"]} ${activeTab === "cost-of-living" && (CostToStudy_module_default())["active-tab"]}`,
                                    onClick: ()=>handleTabClick("cost-of-living"),
                                    children: "Cost of Living"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: cardsArr.length === 1 ? {
                                justifyContent: "center"
                            } : {},
                            className: (CostToStudy_module_default())["cards-container"],
                            children: cardsArr.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: cardsArr.length === 1 ? {
                                        width: "fit-content"
                                    } : {},
                                    className: (CostToStudy_module_default()).card,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CostToStudy_module_default())["card-icon"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: el?.icon ?? "/icons/graduation_cap.svg",
                                                alt: el?.expenseType ?? "",
                                                width: "100%",
                                                height: "100%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (CostToStudy_module_default())["card-content"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: (CostToStudy_module_default())["card-title"],
                                                            children: el?.expenseType ?? ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (CostToStudy_module_default())["card-desc"],
                                                            children: el?.description ?? ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (CostToStudy_module_default())["card-fees"],
                                                            children: el?.degree ?? ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (CostToStudy_module_default())["card-currency-info"],
                                                            children: el?.expenseInfo ?? "Annual Expenses in US$"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, index))
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CostToStudy_CostToStudy = (CostToStudy);

// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
// EXTERNAL MODULE: ./components/CountryDetail/Scholarships/Scholarships.module.scss
var Scholarships_module = __webpack_require__(12724);
var Scholarships_module_default = /*#__PURE__*/__webpack_require__.n(Scholarships_module);
// EXTERNAL MODULE: ./components/UI/Icons/DollarEnclosed.tsx
var DollarEnclosed = __webpack_require__(67316);
// EXTERNAL MODULE: ./components/UI/Icons/FeatherNote.tsx
var FeatherNote = __webpack_require__(31331);
;// CONCATENATED MODULE: ./components/CountryDetail/Scholarships/Scholarships.tsx











const ScholarshipCard = ({ scholarship , cardClassName , jotformId  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        className: (Scholarships_module_default())[cardClassName],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Scholarships_module_default()).cardImageWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadComponent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: scholarship?.image?.url ?? "/images/university-detail-gallery/university-dummy-logo.jpg",
                        alt: scholarship?.image?.name ?? "",
                        className: (Scholarships_module_default()).cardImage,
                        loading: "lazy",
                        decoding: "async"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Scholarships_module_default())["card-content"],
                children: [
                    scholarship?.subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Scholarships_module_default())["university-title"],
                        children: scholarship.subTitle
                    }),
                    scholarship?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (Scholarships_module_default())["scholarship-title"],
                        children: scholarship.title
                    }),
                    scholarship?.amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Scholarships_module_default())["scholarship-amount"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DollarEnclosed/* default */.Z, {
                                width: 19,
                                height: 19
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Scholarships_module_default())["text-amount"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Amount : "
                                    }),
                                    " ",
                                    scholarship.amount
                                ]
                            })
                        ]
                    }),
                    scholarship?.type && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Scholarships_module_default())["scholarship-type"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatherNote/* default */.Z, {
                                width: 19,
                                height: 19
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Scholarships_module_default())["text-type"],
                                children: [
                                    "Scholarship Type : ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: scholarship.type
                                    })
                                ]
                            })
                        ]
                    }),
                    scholarship.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Scholarships_module_default())["scholarship-description"],
                        children: scholarship.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: `${(Scholarships_module_default())["enquiry-btn"]} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotformId)}`,
                children: "Apply Now"
            })
        ]
    });
const Scholarships = ({ countryData , scholarshipsData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { 0: scholarships , 1: setScholarships  } = (0,react.useState)([]);
    const [emblaRef, emblaApi] = (0,embla_carousel_react_esm/* default */.Z)({
        loop: false,
        align: "start"
    });
    const { 0: canScrollPrev , 1: setCanScrollPrev  } = (0,react.useState)(false);
    const { 0: canScrollNext , 1: setCanScrollNext  } = (0,react.useState)(false);
    const scholarshipSectionData = countryData?.scholarships;
    (0,react.useEffect)(()=>{
        setScholarships(scholarshipsData?.scholarshipsPrograms?.popularCountryPrograms ?? []);
    }, [
        countryData,
        scholarshipsData
    ]);
    (0,react.useEffect)(()=>{
        if (!emblaApi) return;
        const updateScrollState = ()=>{
            setCanScrollPrev(emblaApi.canScrollPrev());
            setCanScrollNext(emblaApi.canScrollNext());
        };
        updateScrollState();
        emblaApi.on("select", updateScrollState);
        emblaApi.on("reInit", updateScrollState);
        return ()=>{
            emblaApi.off("select", updateScrollState);
            emblaApi.off("reInit", updateScrollState);
        };
    }, [
        emblaApi,
        scholarships
    ]);
    const goToPrev = ()=>emblaApi?.scrollPrev();
    const goToNext = ()=>emblaApi?.scrollNext();
    const viewMoreClickHandler = ()=>{
        window.open(`/student-services/study-abroad-scholarships/${countryData?.slug?.replace("study-in-", "")}`, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "scholarships",
        className: (Scholarships_module_default())["scholarships-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Scholarships_module_default())["scholarships-title"],
                children: scholarshipSectionData?.title ?? ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Scholarships_module_default())["scholarships-description"],
                dangerouslySetInnerHTML: {
                    __html: scholarshipSectionData?.description ?? ""
                }
            }),
            isMobile ? // Mobile View
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Scholarships_module_default())["scholarships-cards-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Scholarships_module_default()).viewport,
                        ref: emblaRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Scholarships_module_default())["scholarships-cards-slider-container"],
                            children: scholarships.map((scholarship)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Scholarships_module_default()).slide,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScholarshipCard, {
                                        scholarship: scholarship,
                                        cardClassName: "bootstrap-card-mobile",
                                        jotformId: scholarshipsData?.meta?.jotforms?.[0]?.jotformid
                                    })
                                }, scholarship?.id))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Scholarships_module_default())["arrows-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Scholarships_module_default()).btcircle}${canScrollPrev ? "" : ` ${(Scholarships_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollPrev ? goToPrev : undefined,
                                "aria-disabled": !canScrollPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Scholarships_module_default()).btcircle}${canScrollNext ? "" : ` ${(Scholarships_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollNext ? goToNext : undefined,
                                "aria-disabled": !canScrollNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "right-arrow"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Scholarships_module_default())["scholarships-cards-container"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Scholarships_module_default()).viewport,
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Scholarships_module_default())["scholarships-cards-slider-container"],
                                children: scholarships.map((scholarship)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Scholarships_module_default()).slide,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScholarshipCard, {
                                            scholarship: scholarship,
                                            cardClassName: "bootstrap-card",
                                            jotformId: scholarshipsData?.meta?.jotforms?.[0]?.jotformid
                                        })
                                    }, scholarship?.id))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Scholarships_module_default())["arrows-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Scholarships_module_default()).btcircle}${canScrollPrev ? "" : ` ${(Scholarships_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollPrev ? goToPrev : undefined,
                                "aria-disabled": !canScrollPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(Scholarships_module_default()).btcircle}${canScrollNext ? "" : ` ${(Scholarships_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollNext ? goToNext : undefined,
                                "aria-disabled": !canScrollNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "right-arrow"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: viewMoreClickHandler,
                className: (Scholarships_module_default())["view-more-scholarships-btn"],
                children: "View More Scholarships"
            })
        ]
    });
};
/* harmony default export */ var Scholarships_Scholarships = (Scholarships);

// EXTERNAL MODULE: ./components/CountryDetail/Intake/Intake.module.scss
var Intake_module = __webpack_require__(61910);
var Intake_module_default = /*#__PURE__*/__webpack_require__.n(Intake_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Intake/Intake.tsx




const Intake = ({ intakeData  })=>{
    const handleIntakeClick = (link)=>{
        if (!link) return;
        window.open(link, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "intakes",
        className: (Intake_module_default())["intake-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Intake_module_default())["intake-title"],
                children: intakeData?.title ?? ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Intake_module_default())["intake-description"],
                dangerouslySetInnerHTML: {
                    __html: intakeData?.description ?? ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Intake_module_default())["intake-cards-container"],
                children: intakeData?.intakeList?.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `${(Intake_module_default())["intake-card"]} ${el.link ? (Intake_module_default())["intake-card-clickable"] : ""}`,
                        onClick: ()=>handleIntakeClick(el.link),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Intake_module_default())["intake-card-bg"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: el.imgLink ?? "/images/default-intake-bg.jpg",
                                    alt: el.title,
                                    layout: "fill",
                                    objectFit: "cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Intake_module_default())["intake-card-content"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (Intake_module_default())["intake-card-title"],
                                        children: el.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Intake_module_default())["intake-card-description"],
                                        children: el.description
                                    })
                                ]
                            })
                        ]
                    }, el.id))
            })
        ]
    });
};
/* harmony default export */ var Intake_Intake = (Intake);

// EXTERNAL MODULE: ./components/CountryDetail/Elligibility/Elligibility.module.scss
var Elligibility_module = __webpack_require__(14033);
var Elligibility_module_default = /*#__PURE__*/__webpack_require__.n(Elligibility_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Elligibility/Elligibility.tsx





function Elligibility({ countryData  }) {
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { 0: activeTab , 1: setActiveTab  } = (0,react.useState)("");
    const { 0: eligibilityData , 1: setEligibilityData  } = (0,react.useState)([]);
    const { 0: filteredTabData , 1: setFilteredTabData  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const tabs = countryData?.eligibility?.eligibilityTab ?? [];
        setActiveTab(tabs[0]?.name ?? "");
    }, [
        countryData
    ]);
    (0,react.useEffect)(()=>{
        let tempEligibilityData = countryData?.eligibility?.eligibilityTab ?? [];
        setEligibilityData(tempEligibilityData ?? []);
        let tempData = tempEligibilityData?.filter((tab)=>tab?.name === activeTab);
        setFilteredTabData(tempData ?? []);
    }, [
        countryData,
        activeTab
    ]);
    const handleTabClick = (tab)=>()=>{
            setActiveTab(tab);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "eligibility",
        className: (Elligibility_module_default())["elligibility-container"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Elligibility_module_default())["elligibility-card"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Elligibility_module_default())["elligibility-title"],
                    children: countryData?.eligibility?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Elligibility_module_default())["elligibility-description"],
                    dangerouslySetInnerHTML: {
                        __html: countryData?.eligibility?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Elligibility_module_default())["sub-card-container"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Elligibility_module_default())["tab-container"],
                            children: eligibilityData?.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: `${(Elligibility_module_default())["tab-button"]} ${activeTab === el?.name && (Elligibility_module_default())["active-tab"]}`,
                                    onClick: handleTabClick(el?.name),
                                    children: el?.name
                                }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Elligibility_module_default())["sub-card"],
                            children: [
                                filteredTabData[0]?.image?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Elligibility_module_default())["sub-card-image"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: filteredTabData[0]?.image?.url,
                                        alt: "academic-qualifications",
                                        width: 135,
                                        height: 135,
                                        objectFit: "cover",
                                        className: (Elligibility_module_default())["image-wrapper"]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: !isMobile && !filteredTabData[0]?.image?.url ? {
                                        padding: "0 24px"
                                    } : {},
                                    className: (Elligibility_module_default())["sub-card-content"],
                                    children: [
                                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (Elligibility_module_default())["sub-card-content-item-title"],
                                            children: filteredTabData[0]?.name ?? ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Elligibility_module_default())["sub-card-content-item"],
                                            children: [
                                                filteredTabData[0]?.title1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: (Elligibility_module_default())["sub-card-content-item-title"],
                                                    children: filteredTabData[0]?.title1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Elligibility_module_default())["sub-card-content-item-description"],
                                                    dangerouslySetInnerHTML: {
                                                        __html: filteredTabData[0]?.title1Desc ?? ""
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Elligibility_module_default())["sub-card-content-item"],
                                            children: [
                                                filteredTabData[0]?.title2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: (Elligibility_module_default())["sub-card-content-item-title"],
                                                    children: filteredTabData[0]?.title2
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Elligibility_module_default())["sub-card-content-item-description"],
                                                    dangerouslySetInnerHTML: {
                                                        __html: filteredTabData[0]?.title2Desc ?? ""
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Elligibility_Elligibility = (Elligibility);

// EXTERNAL MODULE: ./components/CountryDetail/Exams/Exams.module.scss
var Exams_module = __webpack_require__(47442);
var Exams_module_default = /*#__PURE__*/__webpack_require__.n(Exams_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Exams/Exams.tsx




const Exams = ({ countryData  })=>{
    const examsData = countryData?.examSection ?? [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "exams",
        className: (Exams_module_default())["exams-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Exams_module_default())["exams-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Exams_module_default())["exams-heading"],
                    children: examsData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Exams_module_default())["exams-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: examsData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Exams_module_default())["exams-grid"],
                    children: examsData?.examPages?.items && examsData?.examPages?.items?.length > 0 && examsData?.examPages?.items?.map((exam)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (Exams_module_default())["exam-card"],
                            href: `/coaching/${exam?.exam_page?.slug}`,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Exams_module_default())["exam-card__image-wrapper"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: exam?.exam_page?.logo?.url ?? "/images/default-exam-image.jpg",
                                    alt: exam?.exam_page?.name,
                                    width: 150,
                                    height: 150,
                                    objectFit: "contain"
                                })
                            })
                        }, exam.id))
                })
            ]
        })
    });
};
/* harmony default export */ var Exams_Exams = (Exams);

// EXTERNAL MODULE: ./components/CountryDetail/ApplicationRequirements/ApplicationRequirements.module.scss
var ApplicationRequirements_module = __webpack_require__(75788);
var ApplicationRequirements_module_default = /*#__PURE__*/__webpack_require__.n(ApplicationRequirements_module);
;// CONCATENATED MODULE: ./components/CountryDetail/ApplicationRequirements/ApplicationRequirements.tsx




const ApplicationRequirements = ({ countryData  })=>{
    const requirementsData = countryData?.requirements ?? [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "application",
        className: (ApplicationRequirements_module_default())["ar-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ApplicationRequirements_module_default())["ar-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (ApplicationRequirements_module_default())["ar-heading"],
                    children: requirementsData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ApplicationRequirements_module_default())["ar-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: requirementsData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ApplicationRequirements_module_default())["ar-grid"],
                    children: requirementsData?.applicationRequirements?.map((req)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ApplicationRequirements_module_default())["ar-card"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ApplicationRequirements_module_default())["ar-card__icon"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: req.icon?.url ?? "/images/default-application-requirement-icon.jpg",
                                        alt: req.title,
                                        width: 32,
                                        height: 32
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ApplicationRequirements_module_default())["ar-card__content"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (ApplicationRequirements_module_default())["ar-card__title"],
                                            children: req.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ApplicationRequirements_module_default())["ar-card__desc"],
                                            dangerouslySetInnerHTML: {
                                                __html: req?.description ?? ""
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, req.id))
                })
            ]
        })
    });
};
/* harmony default export */ var ApplicationRequirements_ApplicationRequirements = (ApplicationRequirements);

// EXTERNAL MODULE: ./components/CountryDetail/StudentVisa/StudentVisa.module.scss
var StudentVisa_module = __webpack_require__(84957);
var StudentVisa_module_default = /*#__PURE__*/__webpack_require__.n(StudentVisa_module);
;// CONCATENATED MODULE: ./components/CountryDetail/StudentVisa/StudentVisa.tsx




const StudentVisa = ({ countryData  })=>{
    const { 0: remainingDocCount , 1: setRemainingDocCount  } = (0,react.useState)(0);
    const studentVisaData = countryData?.studentVisa ?? [];
    (0,react.useEffect)(()=>{
        if (studentVisaData?.visaDocuments?.length > 0) {
            setRemainingDocCount(countryData?.studentVisa?.visaDocuments?.length - 3);
        }
    }, [
        countryData
    ]);
    const onCtaClick = (link)=>()=>{
            window.open(link, "_blank");
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "visa",
        className: (StudentVisa_module_default())["sv-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (StudentVisa_module_default())["sv-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (StudentVisa_module_default())["sv-heading"],
                    children: countryData?.studentVisa?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (StudentVisa_module_default())["sv-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: studentVisaData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (StudentVisa_module_default())["sv-stats"],
                    children: studentVisaData?.statCard?.map((stat)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (StudentVisa_module_default())["sv-stat-card"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (StudentVisa_module_default())["sv-stat-card__value"],
                                    children: stat.value ?? ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (StudentVisa_module_default())["sv-stat-card__label"],
                                    children: stat.title ?? ""
                                })
                            ]
                        }, stat.id))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StudentVisa_module_default())["sv-bottom"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (StudentVisa_module_default())["sv-docs"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (StudentVisa_module_default())["sv-docs__title"],
                                    children: "Documents Required for Visa Application"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (StudentVisa_module_default())["sv-docs__grid"],
                                    children: studentVisaData?.visaDocuments?.length > 0 && studentVisaData?.visaDocuments?.map((doc)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (StudentVisa_module_default())["sv-docs__item"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (StudentVisa_module_default())["sv-docs__item__icon"],
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/icons/double_tickmark.svg",
                                                        alt: "check",
                                                        width: 14,
                                                        height: 6,
                                                        objectFit: "cover"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: doc?.document ?? ""
                                                })
                                            ]
                                        }, doc.id))
                                })
                            ]
                        }),
                        studentVisaData?.cardTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (StudentVisa_module_default())["sv-cta"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (StudentVisa_module_default())["sv-cta__title"],
                                    dangerouslySetInnerHTML: {
                                        __html: studentVisaData?.cardTitle ?? ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (StudentVisa_module_default())["sv-cta__actions"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (StudentVisa_module_default())["sv-cta__desc"],
                                            children: studentVisaData?.cardDescription ?? ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (StudentVisa_module_default())["sv-cta__button"],
                                            onClick: onCtaClick(studentVisaData.btnLink),
                                            children: studentVisaData?.btnText ?? "Guide As PDF"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var StudentVisa_StudentVisa = (StudentVisa);

// EXTERNAL MODULE: ./components/CountryDetail/CareerOutcomes/CareerOutcomes.module.scss
var CareerOutcomes_module = __webpack_require__(5527);
var CareerOutcomes_module_default = /*#__PURE__*/__webpack_require__.n(CareerOutcomes_module);
;// CONCATENATED MODULE: ./hooks/useEmblaOverflow.ts


const defaultOptions = {
    loop: false,
    align: "start"
};
const useEmblaOverflow = (options = defaultOptions)=>{
    const [emblaRef, emblaApi] = (0,embla_carousel_react_esm/* default */.Z)(options);
    const { 0: hasOverflow , 1: setHasOverflow  } = (0,react.useState)(false);
    const { 0: canScrollPrev , 1: setCanScrollPrev  } = (0,react.useState)(false);
    const { 0: canScrollNext , 1: setCanScrollNext  } = (0,react.useState)(false);
    const updateOverflow = (0,react.useCallback)((api)=>{
        if (!api) return;
        setHasOverflow(api.canScrollPrev() || api.canScrollNext());
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
    }, []);
    (0,react.useEffect)(()=>{
        if (!emblaApi) return;
        updateOverflow(emblaApi);
        emblaApi.on("reInit", updateOverflow);
        emblaApi.on("select", updateOverflow);
        emblaApi.on("resize", updateOverflow);
        return ()=>{
            emblaApi.off("reInit", updateOverflow);
            emblaApi.off("select", updateOverflow);
            emblaApi.off("resize", updateOverflow);
        };
    }, [
        emblaApi,
        updateOverflow
    ]);
    const scrollPrev = ()=>emblaApi?.scrollPrev();
    const scrollNext = ()=>emblaApi?.scrollNext();
    return {
        emblaRef,
        emblaApi,
        hasOverflow,
        canScrollPrev,
        canScrollNext,
        scrollPrev,
        scrollNext
    };
};
/* harmony default export */ var hooks_useEmblaOverflow = (useEmblaOverflow);

;// CONCATENATED MODULE: ./components/CountryDetail/CareerOutcomes/CareerOutcomes.tsx






const CareerOutcomes = ({ countryData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { emblaRef , canScrollPrev , canScrollNext , scrollPrev: goToPrev , scrollNext: goToNext  } = hooks_useEmblaOverflow();
    const careerOutcomesData = countryData?.careerOutcomes;
    const arrowLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(CareerOutcomes_module_default())["co-arrow"]}${canScrollPrev ? "" : ` ${(CareerOutcomes_module_default())["co-arrow-disabled"]}`}`,
        onClick: canScrollPrev ? goToPrev : undefined,
        "aria-disabled": !canScrollPrev,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "Previous"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(CareerOutcomes_module_default())["co-arrow"]}${canScrollNext ? "" : ` ${(CareerOutcomes_module_default())["co-arrow-disabled"]}`}`,
        onClick: canScrollNext ? goToNext : undefined,
        "aria-disabled": !canScrollNext,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "Next"
        })
    });
    const arrowButtons = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            arrowLeft,
            arrowRight
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "career",
        className: (CareerOutcomes_module_default())["co-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CareerOutcomes_module_default())["co-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (CareerOutcomes_module_default())["co-heading"],
                    children: careerOutcomesData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CareerOutcomes_module_default())["co-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: careerOutcomesData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (CareerOutcomes_module_default())["co-subheading"],
                    children: "Top Recruiters"
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CareerOutcomes_module_default())["co-carousel-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CareerOutcomes_module_default())["co-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CareerOutcomes_module_default())["co-slider"],
                                children: careerOutcomesData?.topRecruiters?.map((rec)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CareerOutcomes_module_default())["co-slide"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CareerOutcomes_module_default())["co-recruiter-card"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: rec.logo?.url ?? "/new-images/default-logo.svg",
                                                alt: rec.name,
                                                width: 100,
                                                height: 50,
                                                objectFit: "contain"
                                            })
                                        })
                                    }, rec.id))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CareerOutcomes_module_default())["co-arrows-below"],
                            children: arrowButtons
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CareerOutcomes_module_default())["co-carousel-wrap"],
                    children: [
                        arrowLeft,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CareerOutcomes_module_default())["co-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CareerOutcomes_module_default())["co-slider"],
                                children: careerOutcomesData?.topRecruiters?.map((rec)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CareerOutcomes_module_default())["co-slide"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CareerOutcomes_module_default())["co-recruiter-card"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: rec.logo?.url ?? "/new-images/default-logo.svg",
                                                alt: rec.name,
                                                width: 120,
                                                height: 50,
                                                objectFit: "contain"
                                            })
                                        })
                                    }, rec.id))
                            })
                        }),
                        arrowRight
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (CareerOutcomes_module_default())["co-jobs-heading"],
                    children: careerOutcomesData?.tableTitle ?? ""
                }),
                careerOutcomesData?.jobSalary && careerOutcomesData?.jobSalary?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CareerOutcomes_module_default())["co-table"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `${(CareerOutcomes_module_default())["co-table__row"]} ${(CareerOutcomes_module_default())["co-table__header"]}`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: careerOutcomesData?.column1Title ?? ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: careerOutcomesData?.column2Title ?? ""
                                })
                            ]
                        }),
                        careerOutcomesData?.jobSalary?.map((job)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CareerOutcomes_module_default())["co-table__row"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: job.jobProfile
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: job.averageSalary
                                    })
                                ]
                            }, job.id))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (CareerOutcomes_module_default())["co-note"],
                    children: careerOutcomesData?.tableNote ?? ""
                })
            ]
        })
    });
};
/* harmony default export */ var CareerOutcomes_CareerOutcomes = (CareerOutcomes);

// EXTERNAL MODULE: ./components/CountryDetail/TopCities/TopCities.module.scss
var TopCities_module = __webpack_require__(58301);
var TopCities_module_default = /*#__PURE__*/__webpack_require__.n(TopCities_module);
// EXTERNAL MODULE: ./components/UI/Spinner/Spinner.tsx
var Spinner = __webpack_require__(63098);
;// CONCATENATED MODULE: ./components/CountryDetail/TopCities/TopCities.tsx










const TopCities = ({ countryData  })=>{
    const citiesData = countryData?.studentFriendlyCities ?? {};
    const defaultActiveId = citiesData?.cities?.[0]?.id ?? 1;
    const { 0: activeId , 1: setActiveId  } = (0,react.useState)(defaultActiveId);
    const { 0: activeCity , 1: setActiveCity  } = (0,react.useState)(null);
    const { 0: activeCityUniversities , 1: setActiveCityUniversities  } = (0,react.useState)([]);
    const { 0: uniLoading , 1: setUniLoading  } = (0,react.useState)(false);
    const isMobile = (0,useIsMobile/* default */.Z)(1250);
    const { emblaRef , canScrollPrev , canScrollNext , scrollPrev: goToPrev , scrollNext: goToNext  } = hooks_useEmblaOverflow();
    (0,react.useEffect)(()=>{
        let cancelled = false;
        const activeCity = citiesData?.cities?.find((c)=>c.id === activeId);
        setActiveCity(activeCity);
        setUniLoading(true);
        const getUniIds = activeCity?.universities?.map((uni)=>uni?.university?.id) ?? [];
        if (getUniIds.length === 0) {
            setActiveCityUniversities([]);
            setUniLoading(false);
            return;
        }
        const buildUrl = `/universities?id_in=${getUniIds.join("&id_in=")}&_publicationState=live&_locale=en`;
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}${buildUrl}`, "GET", {}, "", false).then((res)=>{
            if (cancelled) return;
            const universities = Array.isArray(res) ? res : [];
            const orderedUniversities = getUniIds.map((id)=>universities.find((uni)=>uni.id === id)).filter(Boolean);
            setActiveCityUniversities(orderedUniversities);
        }).catch((err)=>{
            if (!cancelled) setActiveCityUniversities([]);
        }).finally(()=>{
            if (!cancelled) setUniLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        activeId
    ]);
    const handleCityClick = (city)=>{
        setActiveId(city.id);
    };
    const arrowLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(TopCities_module_default())["tc-arrow"]}${canScrollPrev ? "" : ` ${(TopCities_module_default())["tc-arrow-disabled"]}`}`,
        onClick: canScrollPrev ? goToPrev : undefined,
        "aria-disabled": !canScrollPrev,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "Previous"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(TopCities_module_default())["tc-arrow"]}${canScrollNext ? "" : ` ${(TopCities_module_default())["tc-arrow-disabled"]}`}`,
        onClick: canScrollNext ? goToNext : undefined,
        "aria-disabled": !canScrollNext,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "Next"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "cities",
        className: (TopCities_module_default())["tc-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TopCities_module_default())["tc-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (TopCities_module_default())["tc-heading"],
                    children: citiesData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TopCities_module_default())["tc-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: citiesData?.description ?? ""
                    }
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopCities_module_default())["tc-carousel-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TopCities_module_default())["tc-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TopCities_module_default())["tc-slider"],
                                children: citiesData?.cities?.map((city)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TopCities_module_default())["tc-slide"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: `${(TopCities_module_default())["tc-pill"]} ${activeId === city.id ? (TopCities_module_default())["tc-pill--active"] : ""}`,
                                            onClick: ()=>handleCityClick(city),
                                            children: city.name
                                        })
                                    }, city.id))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopCities_module_default())["tc-arrows-below"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopCities_module_default())["tc-carousel-wrap--desktop"],
                    children: [
                        arrowLeft,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TopCities_module_default())["tc-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TopCities_module_default())["tc-slider"],
                                children: citiesData?.cities?.map((city)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TopCities_module_default())["tc-slide"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: `${(TopCities_module_default())["tc-pill"]} ${activeId === city.id ? (TopCities_module_default())["tc-pill--active"] : ""}`,
                                            onClick: ()=>handleCityClick(city),
                                            children: city.name
                                        })
                                    }, city.id))
                            })
                        }),
                        arrowRight
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopCities_module_default())["tc-detail"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopCities_module_default())["tc-detail__info"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (TopCities_module_default())["tc-detail__heading"],
                                    children: activeCity?.aboutHeading ?? `About studying in ${activeCity?.name}`
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (TopCities_module_default())["tc-detail__desc"],
                                    children: activeCity?.description
                                }),
                                activeCity?.universities && activeCity?.universities?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        activeCity.image && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TopCities_module_default())["tc-detail__image"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: activeCity?.image?.url ?? "/new-images/default-image.jpg",
                                                alt: activeCity?.name,
                                                layout: "fill",
                                                objectFit: "fill",
                                                height: "100%",
                                                width: "100%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: (TopCities_module_default())["tc-detail__uni-heading"],
                                            children: activeCity?.universityListHeading ?? `Top Universities to Study in ${activeCity?.name}`
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TopCities_module_default())["tc-detail__uni-list"],
                                            children: uniLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TopCities_module_default())["loading-container"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
                                            }) : activeCityUniversities?.length > 0 && activeCityUniversities?.map((uni, idx)=>{
                                                const slug = uni.slug;
                                                const url = slug && uni.country ? `/universities/${(0,helpers/* getSlugFromCountryUniDetail */.gX)(uni.country, constants/* unicountries */.SS)}/${slug}` : "";
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: `${(TopCities_module_default())["tc-detail__uni-row"]} ${url ? (TopCities_module_default())["tc-detail__uni-row--clickable"] : ""}`,
                                                    onClick: url ? ()=>window.open(url, "_blank") : undefined,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (TopCities_module_default())["tc-detail__uni-logo"],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: uni.image?.imageUrl ?? "/new-images/default-logo.svg",
                                                                width: 60,
                                                                height: 40,
                                                                alt: uni.name,
                                                                objectFit: "contain"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (TopCities_module_default())["tc-detail__uni-name"],
                                                            children: uni?.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/right-arrow.svg",
                                                            width: 8,
                                                            height: 14,
                                                            alt: "View",
                                                            className: (TopCities_module_default())["tc-detail__uni-chevron"]
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeCity?.image && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TopCities_module_default())["tc-detail__image"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: activeCity?.image?.url ?? "/new-images/default-image.jpg",
                                alt: activeCity?.name,
                                layout: "fill",
                                objectFit: "fill",
                                height: "100%",
                                width: "100%"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TopCities_TopCities = (TopCities);

// EXTERNAL MODULE: ./components/CountryDetail/QuickReels/QuickReels.module.scss
var QuickReels_module = __webpack_require__(32164);
var QuickReels_module_default = /*#__PURE__*/__webpack_require__.n(QuickReels_module);
// EXTERNAL MODULE: ./components/LazyMedia/index.tsx
var LazyMedia = __webpack_require__(37462);
;// CONCATENATED MODULE: ./components/CountryDetail/QuickReels/QuickReels.tsx








const ReelCard = ({ reel  })=>{
    const { 0: isPlaying , 1: setIsPlaying  } = (0,react.useState)(false);
    const handlePlay = ()=>{
        if (reel.link) setIsPlaying(true);
    };
    if (isPlaying) {
        const embedBase = (0,helpers/* convertYouTubeToEmbed */.gE)(reel.link) ?? reel.link;
        const sep = embedBase.includes("?") ? "&" : "?";
        const embedSrc = `${embedBase}${sep}autoplay=1`;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (QuickReels_module_default())["reel-card"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                iframeClassName: (QuickReels_module_default())["tm-video"],
                src: embedSrc,
                title: "YouTube video player",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            })
        });
    }
    const videoId = (0,helpers/* getYouTubeVideoId */.Ei)(reel.link);
    const youtubeThumbSrc = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
    const customThumbnail = reel?.thumbnail?.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (QuickReels_module_default())["reel-card"],
        onClick: handlePlay,
        children: [
            youtubeThumbSrc || customThumbnail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                src: customThumbnail || youtubeThumbSrc,
                alt: reel.title || "Video thumbnail",
                layout: "fill",
                objectFit: customThumbnail ? "fill" : "cover"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuickReels_module_default())["reel-placeholder"]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuickReels_module_default())["play-overlay"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (QuickReels_module_default())["play-button-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (QuickReels_module_default())["play-button"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "16",
                            height: "18",
                            viewBox: "0 0 16 18",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M15 7.268a2 2 0 010 3.464L3 17.856A2 2 0 010 16.124V1.876A2 2 0 013 .144L15 7.268z",
                                fill: "#333"
                            })
                        })
                    })
                })
            })
        ]
    });
};
const QuickReels = ({ countryData  })=>{
    const reelsData = countryData?.quickReels ?? [];
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { emblaRef , hasOverflow , canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = hooks_useEmblaOverflow();
    const renderCards = ()=>reelsData?.reels?.map((reel)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuickReels_module_default()).slide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelCard, {
                    reel: reel ?? ""
                })
            }, reel.id));
    const arrowLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(QuickReels_module_default())["arrow-btn"]}${canScrollPrev ? "" : ` ${(QuickReels_module_default())["arrow-btn-disabled"]}`}`,
        onClick: scrollPrev,
        disabled: !canScrollPrev,
        "aria-label": "Previous",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "left-arrow"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(QuickReels_module_default())["arrow-btn"]}${canScrollNext ? "" : ` ${(QuickReels_module_default())["arrow-btn-disabled"]}`}`,
        onClick: scrollNext,
        disabled: !canScrollNext,
        "aria-label": "Next",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "right-arrow"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "quick-reels",
        className: (QuickReels_module_default())["quickreels-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (QuickReels_module_default())["quickreels-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (QuickReels_module_default()).heading,
                    children: reelsData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (QuickReels_module_default()).subtext,
                    dangerouslySetInnerHTML: {
                        __html: reelsData?.description ?? ""
                    }
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (QuickReels_module_default())["carousel-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (QuickReels_module_default()).viewport,
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (QuickReels_module_default())["slider-container"],
                                children: renderCards()
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (QuickReels_module_default())["arrows-container"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: reelsData?.reels?.length < 5 ? {
                                justifyContent: "center"
                            } : {},
                            className: (QuickReels_module_default())["carousel-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (QuickReels_module_default()).viewport,
                                ref: emblaRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: reelsData?.reels?.length < 5 ? {
                                        justifyContent: "center"
                                    } : {},
                                    className: (QuickReels_module_default())["slider-container"],
                                    children: renderCards()
                                })
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (QuickReels_module_default())["arrows-container"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var QuickReels_QuickReels = (QuickReels);

// EXTERNAL MODULE: ./components/CountryDetail/TopAdmits/TopAdmits.module.scss
var TopAdmits_module = __webpack_require__(66421);
var TopAdmits_module_default = /*#__PURE__*/__webpack_require__.n(TopAdmits_module);
;// CONCATENATED MODULE: ./components/CountryDetail/TopAdmits/TopAdmits.tsx






const TopAdmits = ({ countryData  })=>{
    const admitsData = countryData?.topAdmits ?? [];
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { emblaRef , emblaApi , hasOverflow , canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = hooks_useEmblaOverflow();
    const { 0: selectedIndex , 1: setSelectedIndex  } = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (!emblaApi) return;
        const onSelect = ()=>setSelectedIndex(emblaApi.selectedScrollSnap());
        onSelect();
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
        return ()=>{
            emblaApi.off("select", onSelect);
            emblaApi.off("reInit", onSelect);
        };
    }, [
        emblaApi
    ]);
    const renderCards = ()=>admitsData?.admitCard?.map((student, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(TopAdmits_module_default())["ta-slide"]} ${isMobile && index !== selectedIndex ? (TopAdmits_module_default())["ta-slide-inactive"] : ""}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopAdmits_module_default())["ta-card"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopAdmits_module_default())["ta-avatar-wrap"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: student?.image?.url ?? "/icons/student-placeholder.svg",
                                    alt: student?.name,
                                    width: 93,
                                    height: 93,
                                    className: (TopAdmits_module_default())["ta-avatar"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TopAdmits_module_default())["ta-badge"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/icons/medal_icon.svg",
                                        alt: "gold-medal",
                                        width: 73,
                                        height: 73
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (TopAdmits_module_default())["ta-name"],
                            children: student.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (TopAdmits_module_default())["ta-university"],
                            children: student.university
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (TopAdmits_module_default())["ta-intake"],
                            children: student.intake
                        })
                    ]
                })
            }, student?.id));
    const arrowLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(TopAdmits_module_default())["ta-arrow"]}${canScrollPrev ? "" : ` ${(TopAdmits_module_default())["ta-arrow-disabled"]}`}`,
        onClick: scrollPrev,
        disabled: !canScrollPrev,
        "aria-label": "Previous",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "left-arrow"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(TopAdmits_module_default())["ta-arrow"]}${canScrollNext ? "" : ` ${(TopAdmits_module_default())["ta-arrow-disabled"]}`}`,
        onClick: scrollNext,
        disabled: !canScrollNext,
        "aria-label": "Next",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "right-arrow"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "top-admits",
        className: (TopAdmits_module_default())["ta-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TopAdmits_module_default())["ta-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (TopAdmits_module_default())["ta-heading"],
                    children: admitsData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TopAdmits_module_default())["ta-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: admitsData?.description ?? ""
                    }
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopAdmits_module_default())["ta-carousel-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TopAdmits_module_default())["ta-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TopAdmits_module_default())["ta-slider"],
                                children: renderCards()
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopAdmits_module_default())["ta-arrows-below"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: countryData?.topAdmits?.admitCard?.length < 5 ? {
                                justifyContent: "center"
                            } : {},
                            className: (TopAdmits_module_default())["ta-carousel-wrap"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TopAdmits_module_default())["ta-viewport"],
                                ref: emblaRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: countryData?.topAdmits?.admitCard?.length < 5 ? {
                                        justifyContent: "center"
                                    } : {},
                                    className: (TopAdmits_module_default())["ta-slider"],
                                    children: renderCards()
                                })
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopAdmits_module_default())["ta-arrows-container"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TopAdmits_TopAdmits = (TopAdmits);

// EXTERNAL MODULE: ./components/CountryDetail/Testimonials/Testimonials.module.scss
var Testimonials_module = __webpack_require__(48205);
var Testimonials_module_default = /*#__PURE__*/__webpack_require__.n(Testimonials_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Testimonials/Testimonials.tsx







const Testimonials = ({ countryData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(1200);
    const testimonialsData = countryData?.videoTestimonial ?? [];
    const { emblaRef , hasOverflow , canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = hooks_useEmblaOverflow();
    const renderCards = ()=>testimonialsData?.testimonialVideos?.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Testimonials_module_default())["tm-slide"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Testimonials_module_default())["tm-card"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Testimonials_module_default())["tm-quote-icon"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/icons/quote_icon.svg",
                                height: 28,
                                width: 42,
                                alt: "quote"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Testimonials_module_default())["tm-video-area"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                iframeClassName: (Testimonials_module_default())["tm-video"],
                                src: item.videoLink,
                                title: "YouTube video player",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Testimonials_module_default())["tm-text-area"],
                            children: [
                                item?.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (Testimonials_module_default())["tm-name"],
                                    children: item?.name
                                }),
                                item?.university && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Testimonials_module_default())["tm-description"],
                                    children: item?.university
                                })
                            ]
                        })
                    ]
                })
            }, item.id));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (Testimonials_module_default())["tm-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Testimonials_module_default())["tm-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Testimonials_module_default())["tm-heading"],
                    children: testimonialsData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Testimonials_module_default())["tm-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: testimonialsData?.subTitle ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Testimonials_module_default())["tm-carousel-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Testimonials_module_default())["tm-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: !isMobile && testimonialsData?.testimonialVideos?.length < 4 ? {
                                    justifyContent: "center"
                                } : {},
                                className: (Testimonials_module_default())["tm-slider"],
                                children: renderCards()
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Testimonials_module_default())["tm-arrows-below"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: `${(Testimonials_module_default())["tm-arrow"]}${canScrollPrev ? "" : ` ${(Testimonials_module_default())["tm-arrow-disabled"]}`}`,
                                    onClick: scrollPrev,
                                    disabled: !canScrollPrev,
                                    "aria-label": "Previous",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/left-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: `${(Testimonials_module_default())["tm-arrow"]}${canScrollNext ? "" : ` ${(Testimonials_module_default())["tm-arrow-disabled"]}`}`,
                                    onClick: scrollNext,
                                    disabled: !canScrollNext,
                                    "aria-label": "Next",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/right-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "right-arrow"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Testimonials_Testimonials = (Testimonials);

// EXTERNAL MODULE: ./components/CountryDetail/WhyChooseKC/WhyChooseKC.module.scss
var WhyChooseKC_module = __webpack_require__(69205);
var WhyChooseKC_module_default = /*#__PURE__*/__webpack_require__.n(WhyChooseKC_module);
// EXTERNAL MODULE: ./components/UI/Accordion/Accordion.tsx + 1 modules
var Accordion = __webpack_require__(33434);
;// CONCATENATED MODULE: ./components/CountryDetail/WhyChooseKC/WhyChooseKC.tsx






const WhyChooseKC = ({ countryData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const whyChooseKCData = countryData?.whyChooseKc ?? [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "why-choose-kc",
        className: (WhyChooseKC_module_default())["wc-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (WhyChooseKC_module_default())["wc-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (WhyChooseKC_module_default())["wc-heading"],
                    children: whyChooseKCData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhyChooseKC_module_default())["wc-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: whyChooseKCData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (WhyChooseKC_module_default())["wc-columns"],
                    children: [
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (WhyChooseKC_module_default())["wc-images"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (WhyChooseKC_module_default())["wc-img-back"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: whyChooseKCData?.backImage?.url ?? "/icons/placeholder-image.svg",
                                        alt: "Why choose KC",
                                        width: 240,
                                        height: 350,
                                        layout: "responsive",
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (WhyChooseKC_module_default())["wc-img-front"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: whyChooseKCData?.frontImage?.url ?? "/icons/placeholder-image.svg",
                                        alt: "Why choose KC",
                                        width: 240,
                                        height: 350,
                                        layout: "responsive",
                                        objectFit: "cover"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (WhyChooseKC_module_default())["wc-accordion"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                titleStyles: {
                                    fontSize: "18px"
                                },
                                contentStyles: {
                                    fontSize: "16px"
                                },
                                items: whyChooseKCData?.services ?? [],
                                defaultOpenIndex: 0,
                                theme: "card"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var WhyChooseKC_WhyChooseKC = (WhyChooseKC);

// EXTERNAL MODULE: ./components/CountryDetail/Articles/Articles.module.scss
var Articles_module = __webpack_require__(34852);
var Articles_module_default = /*#__PURE__*/__webpack_require__.n(Articles_module);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
;// CONCATENATED MODULE: ./components/CountryDetail/Articles/Articles.tsx








const Articles = ({ countryData , blogsData , blogsSectionData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { emblaRef , hasOverflow , canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = hooks_useEmblaOverflow();
    const renderCards = ()=>blogsData?.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Articles_module_default())["ar-slide"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: `/blogs/${article.slug}`,
                    target: "_blank",
                    "aria-label": article.title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Articles_module_default())["ar-card"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Articles_module_default())["ar-thumbnail"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: article.blogLandingCardImage?.imageUrl || article.newimageUrl?.imageUrl || article.imageUrl || "/icons/placeholder-image.svg",
                                    alt: article.blogLandingCardImage?.alt || article.newimageUrl?.alt || article.title,
                                    layout: "fill",
                                    objectFit: "fill"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Articles_module_default())["ar-text-area"],
                                children: [
                                    article.stu_dest_categories?.[0]?.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Articles_module_default())["ar-category"],
                                        children: article.stu_dest_categories[0].category
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (Articles_module_default())["ar-title"],
                                        children: article.title
                                    }),
                                    article.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Articles_module_default())["ar-description"],
                                        children: article.shortDescription
                                    }),
                                    article.date && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Articles_module_default())["ar-meta"],
                                        children: (0,format["default"])(new Date(article.date), constants/* formatOrder */.iV)
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, article.id));
    const arrowLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(Articles_module_default())["ar-arrow"]}${canScrollPrev ? "" : ` ${(Articles_module_default())["ar-arrow-disabled"]}`}`,
        onClick: scrollPrev,
        disabled: !canScrollPrev,
        "aria-label": "Previous",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "left-arrow"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(Articles_module_default())["ar-arrow"]}${canScrollNext ? "" : ` ${(Articles_module_default())["ar-arrow-disabled"]}`}`,
        onClick: scrollNext,
        disabled: !canScrollNext,
        "aria-label": "Next",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "right-arrow"
        })
    });
    if (!blogsData?.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "blogs",
        className: (Articles_module_default())["ar-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Articles_module_default())["ar-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Articles_module_default())["ar-heading"],
                    children: blogsSectionData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Articles_module_default())["ar-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: blogsSectionData?.description ?? ""
                    }
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Articles_module_default())["ar-carousel-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Articles_module_default())["ar-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Articles_module_default())["ar-slider"],
                                children: renderCards()
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Articles_module_default())["ar-arrows-below"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Articles_module_default())["ar-carousel-wrap"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Articles_module_default())["ar-viewport"],
                                ref: emblaRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Articles_module_default())["ar-slider"],
                                    children: renderCards()
                                })
                            })
                        }),
                        hasOverflow && blogsData.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Articles_module_default())["ar-arrows-container"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Articles_Articles = (Articles);

// EXTERNAL MODULE: ./components/CountryDetail/FAQs/FAQs.module.scss
var FAQs_module = __webpack_require__(54874);
var FAQs_module_default = /*#__PURE__*/__webpack_require__.n(FAQs_module);
;// CONCATENATED MODULE: ./components/CountryDetail/FAQs/FAQs.tsx




const FAQs = ({ countryData  })=>{
    const { 0: accordionData , 1: setAccordionData  } = (0,react.useState)([]);
    const faqsData = countryData?.faq ?? [];
    (0,react.useEffect)(()=>{
        const tempAccordionData = faqsData?.faqPoints?.map((item)=>({
                title: item?.title,
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: item?.description
                    }
                })
            }));
        setAccordionData(tempAccordionData ?? []);
    }, [
        countryData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "faqs",
        className: (FAQs_module_default())["faq-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FAQs_module_default())["faq-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (FAQs_module_default())["faq-heading"],
                    children: faqsData?.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FAQs_module_default())["faq-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: faqsData?.subTitle1 ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    items: accordionData ?? [],
                    defaultOpenIndex: 0,
                    theme: "base"
                })
            ]
        })
    });
};
/* harmony default export */ var FAQs_FAQs = (FAQs);

// EXTERNAL MODULE: ./components/CountryDetail/RelatedLinks/RelatedLinks.module.scss
var RelatedLinks_module = __webpack_require__(90128);
var RelatedLinks_module_default = /*#__PURE__*/__webpack_require__.n(RelatedLinks_module);
;// CONCATENATED MODULE: ./components/CountryDetail/RelatedLinks/RelatedLinks.tsx






const RelatedLinks = ({ countryData  })=>{
    const linksData = countryData?.importantLinksSection ?? [];
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { emblaRef , hasOverflow , canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = hooks_useEmblaOverflow();
    const renderCards = ()=>linksData?.importantLinks && linksData?.importantLinks?.length > 0 && linksData?.importantLinks?.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RelatedLinks_module_default())["rl-slide"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (RelatedLinks_module_default())["rl-card"],
                    onClick: ()=>window.open(link?.href ?? "", "_blank"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RelatedLinks_module_default())["rl-thumbnail"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: link.image?.url ?? "/icons/placeholder-image.svg",
                                alt: link.title,
                                className: (RelatedLinks_module_default())["rl-thumbnail-img"],
                                layout: "fill",
                                objectFit: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (RelatedLinks_module_default())["rl-title"],
                            children: link?.label ?? ""
                        })
                    ]
                })
            }, link.id));
    const arrowLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(RelatedLinks_module_default())["rl-arrow"]}${canScrollPrev ? "" : ` ${(RelatedLinks_module_default())["rl-arrow-disabled"]}`}`,
        onClick: scrollPrev,
        disabled: !canScrollPrev,
        "aria-label": "Previous",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "left-arrow"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: `${(RelatedLinks_module_default())["rl-arrow"]}${canScrollNext ? "" : ` ${(RelatedLinks_module_default())["rl-arrow-disabled"]}`}`,
        onClick: scrollNext,
        disabled: !canScrollNext,
        "aria-label": "Next",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "right-arrow"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "related-links",
        className: (RelatedLinks_module_default())["rl-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (RelatedLinks_module_default())["rl-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (RelatedLinks_module_default())["rl-heading"],
                    children: linksData?.title ?? ""
                }),
                countryData?.importantLinksDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RelatedLinks_module_default())["rl-subtext"],
                    dangerouslySetInnerHTML: {
                        __html: linksData?.description ?? ""
                    }
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (RelatedLinks_module_default())["rl-carousel-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RelatedLinks_module_default())["rl-viewport"],
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (RelatedLinks_module_default())["rl-slider"],
                                children: renderCards()
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RelatedLinks_module_default())["rl-arrows-below"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: linksData?.importantLinks?.length < 4 ? {
                                justifyContent: "center"
                            } : {},
                            className: (RelatedLinks_module_default())["rl-carousel-wrap"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (RelatedLinks_module_default())["rl-viewport"],
                                ref: emblaRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: linksData?.importantLinks?.length < 4 ? {
                                        justifyContent: "center"
                                    } : {},
                                    className: (RelatedLinks_module_default())["rl-slider"],
                                    children: renderCards()
                                })
                            })
                        }),
                        hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RelatedLinks_module_default())["rl-arrows-container"],
                            children: [
                                arrowLeft,
                                arrowRight
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RelatedLinks_RelatedLinks = (RelatedLinks);

// EXTERNAL MODULE: ./utils/loadJotFormScript.ts
var loadJotFormScript = __webpack_require__(97974);
// EXTERNAL MODULE: ./components/CountryDetail/Banner1/Banner1.module.scss
var Banner1_module = __webpack_require__(1961);
var Banner1_module_default = /*#__PURE__*/__webpack_require__.n(Banner1_module);
// EXTERNAL MODULE: ./components/CountryDetail/Banner/Banner.tsx
var Banner = __webpack_require__(74623);
;// CONCATENATED MODULE: ./components/CountryDetail/Banner1/Banner1.tsx







const Banner1 = ({ bannerData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(1100);
    const { 0: bannerFeatures , 1: setBannerFeatures  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        let tempBannerFeatures = [
            bannerData?.banner_feature_1 ?? {},
            bannerData?.banner_feature_2 ?? {}
        ];
        setBannerFeatures(tempBannerFeatures ?? []);
    }, [
        bannerData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
        bannerData: bannerData ?? {},
        bannerStyles: isMobile ? {} : {
            width: "calc(100vw - 429px - 90px"
        },
        bgInverted: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Banner1_module_default())["banner-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Banner1_module_default())["banner-image-container"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                        src: "/images/man_with_foldedhands.png",
                        alt: "banner-image",
                        layout: "fill",
                        objectFit: "cover"
                    })
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Banner1_module_default())["banner-content-container"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (Banner1_module_default())["banner-title"],
                            children: bannerData?.title ?? ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Banner1_module_default())["banner-features-container"],
                            children: bannerFeatures.length > 0 && bannerFeatures.map((feature, index)=>feature.title && feature.subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Banner1_module_default())["banner-feature"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Banner1_module_default())["banner-feature-icon"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "/icons/target_icon.svg",
                                                height: 40,
                                                width: 40,
                                                alt: "banner-feature-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Banner1_module_default())["banner-feature-info"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: feature.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: feature.subtitle
                                                })
                                            ]
                                        })
                                    ]
                                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: `${(Banner1_module_default())["banner-btn"]} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(bannerData?.enquireForm?.url)}`,
                            children: bannerData?.btnLabel ?? ""
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Banner1_module_default())["banner-content-container"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (Banner1_module_default())["banner-title"],
                            children: bannerData?.title ?? ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Banner1_module_default())["banner-features-container"],
                            children: bannerFeatures.map((feature, index)=>feature.title && feature.subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Banner1_module_default())["banner-feature"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Banner1_module_default())["banner-feature-icon"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "/icons/target_icon.svg",
                                                height: 40,
                                                width: 40,
                                                alt: "banner-feature-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Banner1_module_default())["banner-feature-info"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: feature.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: feature.subtitle
                                                })
                                            ]
                                        })
                                    ]
                                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: `${(Banner1_module_default())["banner-btn"]} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(bannerData?.enquireForm?.url)}`,
                            children: bannerData?.btnLabel ?? ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Banner1_module_default())["banner-kc-union-container"],
                    children: !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                        src: "/icons/kc_union.svg",
                        height: "228px",
                        width: "397px",
                        alt: "banner-kc-union-icon"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banner1_Banner1 = (Banner1);

// EXTERNAL MODULE: ./components/CountryDetail/Banner2/Banner2.module.scss
var Banner2_module = __webpack_require__(12882);
var Banner2_module_default = /*#__PURE__*/__webpack_require__.n(Banner2_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Banner2/Banner2.tsx








function chunkArray(array, size) {
    const chunks = [];
    for(let i = 0; i < array.length; i += size){
        chunks.push(array.slice(i, i + size));
    }
    return chunks;
}
const Banner2 = ({ countryData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(900);
    const bannerData = countryData?.banner_2 ?? {};
    const { 0: chunkedFeatureIcons , 1: setChunkedFeatureIcons  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        let tempChunkedFeatureIcons = chunkArray(bannerData?.icons ?? [], isMobile ? 3 : 4);
        setChunkedFeatureIcons(tempChunkedFeatureIcons ?? []);
    }, [
        bannerData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
        bannerData: bannerData ?? {},
        bgInverted: true,
        bannerStyles: isMobile ? {} : {
            width: "calc(100vw - 425px - 90px)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Banner2_module_default())["banner-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Banner2_module_default())["partner-banner-title"],
                    children: bannerData.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Banner2_module_default())["features-container"],
                    children: [
                        Array(3).fill(0).map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Banner2_module_default())["feature-item"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Banner2_module_default())["feature-item-icon"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: "/icons/star_icon.svg",
                                            height: 16,
                                            width: 16,
                                            alt: "banner-feature-icon"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Banner2_module_default())["feature-item-title"],
                                        children: bannerData[`feature_${index + 1}_title`]
                                    })
                                ]
                            })),
                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Banner2_module_default())["feature-icons-container-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Banner2_module_default())["feature-icons-container-mobile"],
                                children: chunkedFeatureIcons.map((row, rowIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `${(Banner2_module_default())["feature-icons-row"]} ${(Banner2_module_default())[`feature-icons-row-${rowIndex}`]}`,
                                        children: row.map((elChild)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                                className: (Banner2_module_default())["feature-card"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Banner2_module_default())["feature-icon-item"],
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: elChild?.url ?? "/icons/placeholder-image.svg",
                                                        height: "39px",
                                                        width: "118px",
                                                        objectFit: "cover",
                                                        alt: "banner-feature-icon"
                                                    })
                                                })
                                            }, elChild.id))
                                    }, rowIndex))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: `${(Banner2_module_default())["appointment-button"]} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(bannerData?.enquireForm?.url)}`,
                            children: bannerData.btnLabel ?? "Fix an Appointment"
                        })
                    ]
                }),
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Banner2_module_default())["feature-icons-container"],
                    children: chunkedFeatureIcons.map((row, rowIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(Banner2_module_default())["feature-icons-row"]} ${(Banner2_module_default())[`feature-icons-row-${rowIndex}`]}`,
                            children: row.map((elChild)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: (Banner2_module_default())["feature-card"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Banner2_module_default())["feature-icon-item"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: elChild?.url ?? "/icons/placeholder-image.svg",
                                            height: "39px",
                                            width: "118px",
                                            objectFit: "cover",
                                            alt: "banner-feature-icon"
                                        })
                                    })
                                }, elChild.id))
                        }, rowIndex))
                })
            ]
        })
    });
};
/* harmony default export */ var Banner2_Banner2 = (Banner2);

// EXTERNAL MODULE: ./components/CountryDetail/Banner3/Banner3.module.scss
var Banner3_module = __webpack_require__(5331);
var Banner3_module_default = /*#__PURE__*/__webpack_require__.n(Banner3_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Banner3/Banner3.tsx







const Banner3 = ({ bannerData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(1024);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
        bannerData: bannerData ?? {},
        bgInverted: false,
        bannerStyles: isMobile ? {} : {
            width: "calc(100vw - 429px - 90px)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Banner3_module_default())["co-banner-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Banner3_module_default())["co-banner-content"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (Banner3_module_default())["co-banner-title"],
                            children: bannerData?.title ?? ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Banner3_module_default())["co-banner-description"],
                            children: bannerData?.subtitle ?? ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Banner3_module_default())["co-banner-btn-container"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: `${(Banner3_module_default())["co-banner-btn"]} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(bannerData?.enquireForm?.url)}`,
                            children: bannerData?.btnLabel ?? ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Banner3_module_default())["kc-overseas-icon"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/icons/kc_union.svg",
                                height: 128,
                                width: 222,
                                alt: "kc-overseas-icon"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Banner3_Banner3 = (Banner3);

// EXTERNAL MODULE: ./components/CountryDetail/Banner4/Banner4.module.scss
var Banner4_module = __webpack_require__(60995);
var Banner4_module_default = /*#__PURE__*/__webpack_require__.n(Banner4_module);
;// CONCATENATED MODULE: ./components/CountryDetail/Banner4/Banner4.tsx







const Banner4 = ({ bannerData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { emblaRef: expertEmblaRef , canScrollPrev , canScrollNext , scrollPrev: goToExpertPrev , scrollNext: goToExpertNext ,  } = hooks_useEmblaOverflow();
    const renderExpertCards = ()=>bannerData?.expertContact?.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Banner4_module_default())["expert-slide"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Banner4_module_default())["expert-card"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Banner4_module_default())["expert-card-content"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Banner4_module_default())["expert-card-image"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: el.image?.url ?? "/icons/expert-image.svg",
                                        height: 59,
                                        width: 59,
                                        alt: "expert-image"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Banner4_module_default())["card-details"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Banner4_module_default())["expert-card-name"],
                                        children: el.name ?? ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>{
                                window.open(el.btnLink ?? "", "_blank");
                            },
                            className: `${(Banner4_module_default())["expert-card-button"]}`,
                            children: el.btnLabel ?? ""
                        })
                    ]
                })
            }, el.id));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
        bannerData: bannerData ?? {},
        bgInverted: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Banner4_module_default())["banner-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Banner4_module_default())["banner-title"],
                    children: bannerData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Banner4_module_default())["banner-description"],
                    children: bannerData?.subtitle ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Banner4_module_default())["experts-carousel-wrapper"],
                    children: [
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: `${(Banner4_module_default())["expert-arrow-btn"]}${canScrollPrev ? "" : ` ${(Banner4_module_default())["expert-arrow-btn-disabled"]}`}`,
                            onClick: goToExpertPrev,
                            disabled: !canScrollPrev,
                            "aria-label": "Previous expert",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/new-images/left-arrow.svg",
                                height: 17,
                                width: 10,
                                alt: "left-arrow"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Banner4_module_default())["expert-viewport"],
                            ref: expertEmblaRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Banner4_module_default())["expert-slider-container"],
                                children: renderExpertCards()
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: `${(Banner4_module_default())["expert-arrow-btn"]}${canScrollNext ? "" : ` ${(Banner4_module_default())["expert-arrow-btn-disabled"]}`}`,
                            onClick: goToExpertNext,
                            disabled: !canScrollNext,
                            "aria-label": "Next expert",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/new-images/right-arrow.svg",
                                height: 17,
                                width: 10,
                                alt: "right-arrow"
                            })
                        }),
                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Banner4_module_default())["expert-arrows-container"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: `${(Banner4_module_default())["expert-arrow-btn"]}${canScrollPrev ? "" : ` ${(Banner4_module_default())["expert-arrow-btn-disabled"]}`}`,
                                    onClick: goToExpertPrev,
                                    disabled: !canScrollPrev,
                                    "aria-label": "Previous expert",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/left-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: `${(Banner4_module_default())["expert-arrow-btn"]}${canScrollNext ? "" : ` ${(Banner4_module_default())["expert-arrow-btn-disabled"]}`}`,
                                    onClick: goToExpertNext,
                                    disabled: !canScrollNext,
                                    "aria-label": "Next expert",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/right-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "right-arrow"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Banner4_Banner4 = (Banner4);

;// CONCATENATED MODULE: ./components/CountryDetail/CountryDetail.tsx






























const CountryDetail = (props)=>{
    const isMobile = (0,useIsMobile/* default */.Z)(1000);
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react.useState)(null);
    const countryData = props.pageData?.[0];
    const scholarshipsData = props.scholarshipsData?.[0];
    const intakeData = props.pageData?.[0]?.intakeSection ?? {};
    const blogsSectionData = props.pageData?.[0].blogsSection ?? {};
    const blogsData = props.blogsData ?? [];
    const handleSelectTab = (tab)=>{};
    (0,react.useEffect)(()=>{
        (0,loadJotFormScript/* loadJotFormScript */.O)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (CountryDetail_module_default())["country-detail-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                countryData: countryData,
                headerHeight: headerHeight,
                setHeaderHeight: setHeaderHeight
            }),
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CountryDetail_module_default())["page-body"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryNav_SecondaryNav, {
                            items: countryData?.menuBar,
                            onSelectTab: handleSelectTab,
                            headerHeight: headerHeight
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CountryDetail_module_default())["section-with-padding"],
                                children: [
                                    countryData.overview && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_Overview, {
                                        countryData: countryData
                                    }),
                                    countryData?.topUniversities && /*#__PURE__*/ (0,jsx_runtime.jsx)(Universities_Universities, {
                                        countryData: countryData
                                    }),
                                    countryData?.topCourses && /*#__PURE__*/ (0,jsx_runtime.jsx)(Courses_Courses, {
                                        countryData: countryData
                                    })
                                ]
                            }),
                            countryData?.banner_1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner1_Banner1, {
                                bannerData: countryData?.banner_1 ?? {}
                            }),
                            countryData?.costToStudySection && /*#__PURE__*/ (0,jsx_runtime.jsx)(CostToStudy_CostToStudy, {
                                countryData: countryData
                            }),
                            scholarshipsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Scholarships_Scholarships, {
                                countryData: countryData,
                                scholarshipsData: scholarshipsData
                            }),
                            intakeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_Intake, {
                                intakeData: intakeData
                            }),
                            countryData?.eligibility && /*#__PURE__*/ (0,jsx_runtime.jsx)(Elligibility_Elligibility, {
                                countryData: countryData
                            }),
                            countryData?.banner_2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner2_Banner2, {
                                countryData: countryData
                            }),
                            countryData?.examSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(Exams_Exams, {
                                countryData: countryData
                            }),
                            countryData?.requirements && /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationRequirements_ApplicationRequirements, {
                                countryData: countryData
                            }),
                            countryData?.studentVisa && /*#__PURE__*/ (0,jsx_runtime.jsx)(StudentVisa_StudentVisa, {
                                countryData: countryData
                            }),
                            countryData?.careerOutcomes && /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerOutcomes_CareerOutcomes, {
                                countryData: countryData
                            }),
                            countryData?.banner_3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner3_Banner3, {
                                bannerData: countryData?.banner_3 ?? {}
                            }),
                            countryData?.studentFriendlyCities && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCities_TopCities, {
                                countryData: countryData
                            }),
                            countryData?.quickReels && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickReels_QuickReels, {
                                countryData: countryData
                            }),
                            countryData?.banner_4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner4_Banner4, {
                                bannerData: countryData?.banner_4 ?? {}
                            }),
                            countryData?.topAdmits && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopAdmits_TopAdmits, {
                                countryData: countryData
                            }),
                            countryData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials_Testimonials, {
                                countryData: countryData
                            }),
                            countryData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyChooseKC_WhyChooseKC, {
                                countryData: countryData
                            }),
                            blogsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Articles_Articles, {
                                countryData: countryData,
                                blogsData: blogsData,
                                blogsSectionData: blogsSectionData
                            }),
                            countryData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs_FAQs, {
                                countryData: countryData
                            }),
                            countryData?.importantLinksSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedLinks_RelatedLinks, {
                                countryData: countryData
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryNav_SecondaryNav, {
                        items: countryData?.menuBar,
                        onSelectTab: handleSelectTab,
                        headerHeight: headerHeight
                    }),
                    countryData.overview && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_Overview, {
                        countryData: countryData
                    }),
                    countryData?.topUniversities && /*#__PURE__*/ (0,jsx_runtime.jsx)(Universities_Universities, {
                        countryData: countryData
                    }),
                    countryData?.topCourses && /*#__PURE__*/ (0,jsx_runtime.jsx)(Courses_Courses, {
                        countryData: countryData
                    }),
                    countryData?.banner_1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner1_Banner1, {
                        bannerData: countryData?.banner_1 ?? {}
                    }),
                    countryData?.costToStudySection && /*#__PURE__*/ (0,jsx_runtime.jsx)(CostToStudy_CostToStudy, {
                        countryData: countryData
                    }),
                    scholarshipsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Scholarships_Scholarships, {
                        countryData: countryData,
                        scholarshipsData: scholarshipsData
                    }),
                    intakeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_Intake, {
                        intakeData: intakeData
                    }),
                    countryData?.eligibility && /*#__PURE__*/ (0,jsx_runtime.jsx)(Elligibility_Elligibility, {
                        countryData: countryData
                    }),
                    countryData?.banner_2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner2_Banner2, {
                        countryData: countryData
                    }),
                    countryData?.examSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(Exams_Exams, {
                        countryData: countryData
                    }),
                    countryData?.requirements && /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationRequirements_ApplicationRequirements, {
                        countryData: countryData
                    }),
                    countryData?.studentVisa && /*#__PURE__*/ (0,jsx_runtime.jsx)(StudentVisa_StudentVisa, {
                        countryData: countryData
                    }),
                    countryData?.careerOutcomes && /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerOutcomes_CareerOutcomes, {
                        countryData: countryData
                    }),
                    countryData?.banner_3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner3_Banner3, {
                        bannerData: countryData?.banner_3 ?? {}
                    }),
                    countryData?.studentFriendlyCities && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCities_TopCities, {
                        countryData: countryData
                    }),
                    countryData?.quickReels && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickReels_QuickReels, {
                        countryData: countryData
                    }),
                    countryData?.banner_4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner4_Banner4, {
                        bannerData: countryData?.banner_4 ?? {}
                    }),
                    countryData?.topAdmits && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopAdmits_TopAdmits, {
                        countryData: countryData
                    }),
                    countryData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials_Testimonials, {
                        countryData: countryData
                    }),
                    countryData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyChooseKC_WhyChooseKC, {
                        countryData: countryData
                    }),
                    blogsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Articles_Articles, {
                        countryData: countryData,
                        blogsData: blogsData,
                        blogsSectionData: blogsSectionData
                    }),
                    countryData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs_FAQs, {
                        countryData: countryData
                    }),
                    countryData?.importantLinksSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedLinks_RelatedLinks, {
                        countryData: countryData
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CountryDetail_CountryDetail = (CountryDetail);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./styles/countrypage.module.scss
var countrypage_module = __webpack_require__(42660);
var countrypage_module_default = /*#__PURE__*/__webpack_require__.n(countrypage_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js
var Tabs = __webpack_require__(85509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Table.js
var Table = __webpack_require__(75147);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/CustomLink.tsx
var CustomLink = __webpack_require__(50282);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/NewNeedGuidance.tsx
var NewNeedGuidance = __webpack_require__(56560);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/LazyReveal.tsx
var LazyReveal = __webpack_require__(70710);
;// CONCATENATED MODULE: ./components/Countrypage.tsx


























const Countrypage = (props)=>{
    const { 0: popularUniversities , 1: setPopularUniversities  } = (0,react.useState)([]);
    const countryData = props.pageData[0];
    const countrySlug = countryData?.name === "UK" ? "uk" : (0,helpers/* getSlugFromCountry */.TX)(countryData?.name, constants/* countries */.hW);
    const isMobile = (0,useIsMobile/* default */.Z)(480);
    (0,react.useEffect)(()=>{
        if (countryData?.name) {
            const countryName = countryData?.name === "UnitedKingdom" ? "UK" : countryData?.name;
            (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/universities?country=${countryName.replace(/ /g, "")}&_start=0&_limit=10&_sort=priority:ASC`, "GET", {}, "", false).then((res)=>setPopularUniversities(res));
        }
    }, [
        countryData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: countryData?.newTopImages?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: countryData?.newTopImages[0]?.imageUrl,
                    as: "image",
                    fetchpriority: "high"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (countrypage_module_default()).edtech,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "country-heading",
                        className: (countrypage_module_default()).breadcrum,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                lg: 9,
                                md: 9,
                                xs: 12,
                                className: (countrypage_module_default()).centered,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                style: {
                                                    opacity: 0.5
                                                },
                                                href: "/study-destinations",
                                                children: "Study Destination"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                href: "",
                                                children: countryData?.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (countrypage_module_default()).abttopContent,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            children: [
                                                " Study In ",
                                                countryData?.name,
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: countryData.newTopImages?.length > 0 ? (isMobile ? [
                                            {
                                                ...countryData?.newTopImages[0]
                                            }
                                        ] : countryData.newTopImages).map((image, ind)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: 12,
                                                md: 6,
                                                className: ind === 1 ? (countrypage_module_default()).hideimg : "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (countrypage_module_default()).imgContainer,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: image?.imageUrl,
                                                        width: 770,
                                                        alt: image.alt,
                                                        height: 500
                                                    })
                                                })
                                            })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xs: 12,
                                                    md: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/canadaa.svg",
                                                        width: 770,
                                                        height: 500,
                                                        alt: "canadaa"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xs: 12,
                                                    md: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/canadab.svg",
                                                        width: 770,
                                                        height: 500,
                                                        alt: "canadab"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                id: "contry-discription",
                className: (countrypage_module_default()).sectionBorder,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            sm: 12,
                            xs: 12,
                            md: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (countrypage_module_default()).centerContent,
                                children: countryData?.description
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (countrypage_module_default()).enquireBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "primary",
                            size: "lg",
                            onClick: ()=>{
                                !countryData?.meta?.jotforms[0]?.jotformid && router_default().push(countryData?.externalLink);
                            },
                            className: `${countryData?.meta?.jotforms[0]?.jotformid ? `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(countryData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                            children: countryData?.bannerBtnText || "Enquire Now"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyReveal/* default */.Z, {
                id: "study-content",
                className: (countrypage_module_default()).studyContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (countrypage_module_default()).service_content,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (countrypage_module_default()).content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: (countrypage_module_default()).h2title,
                                                    children: [
                                                        "Why Study in ",
                                                        countryData?.name,
                                                        "?"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        textAlign: "justify"
                                                    },
                                                    children: countryData?.whyStudy
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (countrypage_module_default()).offers,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Quick facts"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: countryData?.quickFacts?.length > 0 && countryData?.quickFacts.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: typeof item === "string" ? item : item?.fact
                                                    }, item?.id ?? index))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (countrypage_module_default()).costOfeduSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-none d-sm-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (countrypage_module_default()).costofEducation,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    "Cost of Studying in ",
                                                    countryData?.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("thead", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        className: (countrypage_module_default()).headtr,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: "Types of Expenses"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                                                                colSpan: 2,
                                                                                children: [
                                                                                    "Annual Expenses in ",
                                                                                    countryData?.currency
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    countryData?.costOfEducation[0].diploma && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        className: (countrypage_module_default()).headsmalltr,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: "\xa0"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: "Diploma"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: "Degree"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                className: (countrypage_module_default()).customtr,
                                                                children: countryData?.costOfEducation?.length > 0 && countryData?.costOfEducation.map((expense)=>{
                                                                    return !expense.isTotal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        id: expense.id,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                children: expense.expenseType
                                                                            }),
                                                                            expense.diploma && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                children: expense.diploma
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                children: expense.degree
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        id: expense.id,
                                                                        className: (countrypage_module_default()).headsmalltr,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: expense.expenseType
                                                                            }),
                                                                            expense.diploma && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: expense.diploma
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: expense.degree
                                                                            })
                                                                        ]
                                                                    });
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-block d-sm-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (countrypage_module_default()).costofEducation,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (countrypage_module_default()).costofEducation,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    children: [
                                                        "Cost of Studying in  ",
                                                        countryData?.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                                    className: (countrypage_module_default()).headtr,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        colSpan: 2,
                                                                        children: "Types of Expenses"
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        countryData?.costOfEducation[0].diploma ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                                            defaultActiveKey: "diplo",
                                                            className: (countrypage_module_default()).recogTabs,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                                    eventKey: "diplo",
                                                                    title: "Diploma",
                                                                    className: (countrypage_module_default()).custtab,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                            className: (countrypage_module_default()).customtr,
                                                                            children: countryData?.costOfEducation?.length > 0 && countryData?.costOfEducation.map((expense, index)=>{
                                                                                return !expense.isTotal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                    id: expense.id,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                            children: expense.expenseType
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                            children: expense.diploma
                                                                                        })
                                                                                    ]
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                    id: expense.id,
                                                                                    className: (countrypage_module_default()).headsmalltr,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                            children: expense.expenseType
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                            children: expense.diploma
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                                    eventKey: "Degr",
                                                                    title: "Degree",
                                                                    className: (countrypage_module_default()).custtab,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                            className: (countrypage_module_default()).customtr,
                                                                            children: countryData?.costOfEducation?.length > 0 && countryData?.costOfEducation.map((expense)=>{
                                                                                return !expense.isTotal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                    id: expense.id,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                            children: expense.expenseType
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                            children: expense.degree
                                                                                        })
                                                                                    ]
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                    id: expense.id,
                                                                                    className: (countrypage_module_default()).headsmalltr,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                            children: expense.expenseType
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                            children: expense.degree
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                className: (countrypage_module_default()).customtr,
                                                                children: countryData?.costOfEducation?.length > 0 && countryData?.costOfEducation.map((expense)=>{
                                                                    return !expense.isTotal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        id: expense.id,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                children: expense.expenseType
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                children: expense.degree
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        id: expense.id,
                                                                        className: (countrypage_module_default()).headsmalltr,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: expense.expenseType
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: expense.degree
                                                                            })
                                                                        ]
                                                                    });
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    sm: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (countrypage_module_default()).imgRestructured,
                                        children: countryData.newInsightsImages?.length > 0 && countryData.newInsightsImages.map((image, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: index === 0 ? (countrypage_module_default()).picA : (countrypage_module_default()).picB,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: image.imageUrl,
                                                    alt: image.alt,
                                                    width: 250,
                                                    height: 350
                                                })
                                            }))
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    sm: 6,
                                    className: (countrypage_module_default()).indusContent,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (countrypage_module_default()).service_content,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (countrypage_module_default()).content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Careers & Industry Insights"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        textAlign: "justify"
                                                    },
                                                    children: countryData?.insights
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            popularUniversities.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyReveal/* default */.Z, {
                id: "popular-universities",
                className: (countrypage_module_default()).popularUniversities,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                children: [
                                    "Popular Universities in ",
                                    countryData?.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: popularUniversities.map((univ, index)=>index % 2 === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: univ?.image?.imageUrl || "/",
                                                            alt: univ?.image?.alt || "university",
                                                            width: 70,
                                                            height: 70
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: univ?.name
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: popularUniversities.map((univ, index)=>index % 2 !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: univ?.image?.imageUrl || "/",
                                                            alt: univ?.image?.alt || "university",
                                                            width: 70,
                                                            height: 70
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                " ",
                                                                univ?.name
                                                            ]
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center mt-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: `/universities/${countrySlug}`,
                                    className: (countrypage_module_default()).viewMore,
                                    children: " View More "
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyReveal/* default */.Z, {
                id: "popular-courses",
                className: (countrypage_module_default()).popularCourses,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: (countrypage_module_default()).containerSpace,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    md: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: `${"https://assets.studies-overseas.com"}/Popular_Courses_8a19985908.svg`,
                                        alt: "popularCourses.svg",
                                        width: 490,
                                        height: 440
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    md: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (countrypage_module_default()).popcourse,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Popular Courses in ",
                                                    countryData?.name,
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: countryData?.popularCourses?.length > 0 && countryData?.popularCourses.map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (countrypage_module_default()).starimg,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: "/new-images/star-coursees.svg",
                                                                    alt: "StarCoursees.svg",
                                                                    width: 17,
                                                                    height: 17
                                                                })
                                                            }),
                                                            course
                                                        ]
                                                    }, index))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: (countrypage_module_default()).containerSpace,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    md: 6,
                                    className: (countrypage_module_default()).impoLinktext,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Important Links"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: countryData?.importantLinks?.length > 0 && countryData?.importantLinks.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                    data: link,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/new-images/imp-lines.svg",
                                                                alt: "impLines.svg",
                                                                width: 17,
                                                                height: 17
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                className: (countrypage_module_default()).h2text,
                                                                children: link.label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (countrypage_module_default()).morelink,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: "/new-images/more-link-arrow.svg",
                                                                    alt: "moreLinkArrow.svg",
                                                                    width: 24,
                                                                    height: 22
                                                                })
                                                            })
                                                        ]
                                                    }, index)
                                                }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    md: 6,
                                    className: (countrypage_module_default()).impoLinkImg,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: `${"https://assets.studies-overseas.com"}/Important_Links_b99b9b7010.svg`,
                                        alt: "importantlink.svg",
                                        width: 490,
                                        height: 440
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            countryData?.student_testimonials?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                data: countryData?.student_testimonials?.sort((firstTestimonial, secondTestimonial)=>secondTestimonial.id - firstTestimonial.id)?.slice(0, 15),
                title: "Our students love us",
                bgColor: "#ffffff"
            }),
            countryData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                ...countryData.videoTestimonial
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                className: (countrypage_module_default()).homePageLatestKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyReveal/* default */.Z, {
                className: (countrypage_module_default()).homePageBlogs,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (countrypage_module_default()).countryPageBlog,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
                    }),
                    countryData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                        ...countryData.faq
                    })
                ]
            }),
            countryData?.needGuidance && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewNeedGuidance/* default */.Z, {
                data: countryData?.needGuidance,
                jotforms: countryData?.meta?.jotforms,
                externalLink: countryData?.externalLink
            })
        ]
    });
};
/* harmony default export */ var components_Countrypage = (Countrypage);

;// CONCATENATED MODULE: ./pages/country/[slug].tsx






const CountryPage = (props)=>{
    if (!props.pageData || props.pageData.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent/* default */.Z, {});
    }
    const { meta  } = props.pageData[0] || {};
    const slug = props.pageData[0].slug;
    const updatedMeta = meta ? {
        ...meta,
        canonicalUrl: `${"https://www.studies-overseas.com"}/country/${slug}`
    } : null;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            updatedMeta && props.pageData?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...updatedMeta
            }),
            props.mode === "newUI" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryDetail_CountryDetail, {
                ...props
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Countrypage, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (CountryPage);


/***/ }),

/***/ 97974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ loadJotFormScript; }
/* harmony export */ });
const loadJotFormScript = (callback)=>{
    const feedbackScriptId = "jotform-feedback-script";
    if (!document.getElementById(feedbackScriptId)) {
        const feedbackScript = document.createElement("script");
        feedbackScript.src = "https://form.jotform.com/static/feedback2.js";
        feedbackScript.type = "text/javascript";
        feedbackScript.id = feedbackScriptId;
        feedbackScript.onload = ()=>{
            if (callback) callback();
        };
        document.body.appendChild(feedbackScript);
    } else {
        if (callback) callback();
    }
};


/***/ }),

/***/ 75788:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ApplicationRequirements_hide-scrollbar__oDVnR","ar-section":"ApplicationRequirements_ar-section__Euzu8","ar-container":"ApplicationRequirements_ar-container__r0NWi","ar-heading":"ApplicationRequirements_ar-heading__hXtKt","ar-subtext":"ApplicationRequirements_ar-subtext__BGyMk","ar-grid":"ApplicationRequirements_ar-grid__PMreZ","ar-card":"ApplicationRequirements_ar-card__4s0AO","ar-card__icon":"ApplicationRequirements_ar-card__icon__N8r_3","ar-card__content":"ApplicationRequirements_ar-card__content__bTJaS","ar-card__title":"ApplicationRequirements_ar-card__title__JsP5i","ar-card__desc":"ApplicationRequirements_ar-card__desc__6Y_on"};

/***/ }),

/***/ 34852:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Articles_hide-scrollbar__yTKeb","ar-section":"Articles_ar-section__8HS5t","ar-container":"Articles_ar-container__2j4r0","ar-heading":"Articles_ar-heading__G8Tgv","ar-subtext":"Articles_ar-subtext__82XvB","ar-carousel-wrap":"Articles_ar-carousel-wrap__I8pXX","ar-viewport":"Articles_ar-viewport__xJqb_","ar-slider":"Articles_ar-slider__wbYyJ","ar-slide":"Articles_ar-slide__X0GzN","ar-card":"Articles_ar-card__ibMu1","ar-thumbnail":"Articles_ar-thumbnail__tzOoF","ar-text-area":"Articles_ar-text-area__4eWV9","ar-category":"Articles_ar-category__znJE4","ar-title":"Articles_ar-title__Pi5R_","ar-description":"Articles_ar-description__nDgH1","ar-meta":"Articles_ar-meta__sxujk","ar-arrow":"Articles_ar-arrow__B7fZl","ar-arrow-disabled":"Articles_ar-arrow-disabled__TkRo_","ar-arrows-below":"Articles_ar-arrows-below__qwnCx","ar-arrows-container":"Articles_ar-arrows-container__0qAaM"};

/***/ }),

/***/ 76604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner_hide-scrollbar__wUm_f","banner-container-wrapper":"Banner_banner-container-wrapper__FH34m","banner-container":"Banner_banner-container__dfXxn","image-wrapper":"Banner_image-wrapper__DbE96","priority-image-container":"Banner_priority-image-container__Eof0j"};

/***/ }),

/***/ 1961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner1_hide-scrollbar__B5IZd","banner-container":"Banner1_banner-container__vb9eP","banner-content-container":"Banner1_banner-content-container__NrefB","banner-title":"Banner1_banner-title__lTsIH","banner-features-container":"Banner1_banner-features-container__0jdvf","banner-feature":"Banner1_banner-feature___L8pF","banner-feature-info":"Banner1_banner-feature-info__YuDaF","banner-btn":"Banner1_banner-btn__BLANx","banner-kc-union-container":"Banner1_banner-kc-union-container__gYfx4","banner-image-container":"Banner1_banner-image-container__uRzOL"};

/***/ }),

/***/ 12882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner2_hide-scrollbar__q3R93","banner-container":"Banner2_banner-container__fHet6","partner-banner-title":"Banner2_partner-banner-title__3fnkN","features-container":"Banner2_features-container__6z9aN","feature-item":"Banner2_feature-item__jYdpF","feature-item-icon":"Banner2_feature-item-icon__gJg9r","feature-item-title":"Banner2_feature-item-title__yAUaR","appointment-button":"Banner2_appointment-button__xy39R","feature-icons-container-wrapper":"Banner2_feature-icons-container-wrapper__TRgqE","feature-icons-container-mobile":"Banner2_feature-icons-container-mobile__HgKP_","feature-icons-row":"Banner2_feature-icons-row__1CSfA","feature-card":"Banner2_feature-card__hpo_s","feature-icon-item":"Banner2_feature-icon-item__QWzw_","feature-icons-row-0":"Banner2_feature-icons-row-0__wtbBJ","feature-icons-row-1":"Banner2_feature-icons-row-1__lvy2n","feature-icons-row-2":"Banner2_feature-icons-row-2__HFTcG","feature-icons-container":"Banner2_feature-icons-container__4eIdh"};

/***/ }),

/***/ 5331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner3_hide-scrollbar__DSGiH","co-banner-container":"Banner3_co-banner-container__Ew9Uh","co-banner-content":"Banner3_co-banner-content___fsi3","co-banner-title":"Banner3_co-banner-title__giTz3","co-banner-description":"Banner3_co-banner-description__pWYO8","co-banner-btn-container":"Banner3_co-banner-btn-container__YLeNP","co-banner-btn":"Banner3_co-banner-btn__AQqml","kc-overseas-icon":"Banner3_kc-overseas-icon__sBwPs","image-wrapper":"Banner3_image-wrapper__Forg9","priority-image-container":"Banner3_priority-image-container__OBA_n"};

/***/ }),

/***/ 60995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner4_hide-scrollbar__mmlkY","banner-container":"Banner4_banner-container__Wq3kB","banner-title":"Banner4_banner-title__rzYad","banner-description":"Banner4_banner-description__4hCko","experts-carousel-wrapper":"Banner4_experts-carousel-wrapper__XnRpx","expert-viewport":"Banner4_expert-viewport__52Pay","expert-slider-container":"Banner4_expert-slider-container__bjXxF","expert-slide":"Banner4_expert-slide__wgfDL","expert-card":"Banner4_expert-card__LFCGs","expert-card-content":"Banner4_expert-card-content__MvNFb","card-details":"Banner4_card-details__i1yyO","expert-card-name":"Banner4_expert-card-name__GYLOq","icon-wrapper":"Banner4_icon-wrapper__KMNth","expert-card-info":"Banner4_expert-card-info__nvVwY","expert-card-button":"Banner4_expert-card-button__nDGzi","expert-arrows-container":"Banner4_expert-arrows-container__rEzuQ","expert-arrow-btn":"Banner4_expert-arrow-btn__eHRgn","expert-arrow-btn-disabled":"Banner4_expert-arrow-btn-disabled__XBwCR"};

/***/ }),

/***/ 5527:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"CareerOutcomes_hide-scrollbar__oTSMM","co-section":"CareerOutcomes_co-section__pEGyM","co-container":"CareerOutcomes_co-container__VA4qh","co-heading":"CareerOutcomes_co-heading__zBFG5","co-subtext":"CareerOutcomes_co-subtext__hRf5s","co-subheading":"CareerOutcomes_co-subheading__iGlLd","co-carousel-wrap":"CareerOutcomes_co-carousel-wrap__9HOcL","co-viewport":"CareerOutcomes_co-viewport__97KYL","co-slider":"CareerOutcomes_co-slider__aFlFC","co-slide":"CareerOutcomes_co-slide__3snXr","co-recruiter-card":"CareerOutcomes_co-recruiter-card__I2yWP","co-arrow":"CareerOutcomes_co-arrow__aJJwS","co-arrow-disabled":"CareerOutcomes_co-arrow-disabled__Yl5Da","co-arrows-below":"CareerOutcomes_co-arrows-below__sL1_G","co-jobs-heading":"CareerOutcomes_co-jobs-heading__TJ1Lo","co-table":"CareerOutcomes_co-table__DPbEJ","co-table__header":"CareerOutcomes_co-table__header__N1NDh","co-table__row":"CareerOutcomes_co-table__row__GePm4","co-note":"CareerOutcomes_co-note__Ko8tf","co-banner-container":"CareerOutcomes_co-banner-container__KU7a0"};

/***/ }),

/***/ 21263:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"CostToStudy_hide-scrollbar__ccymi","cost-to-study-container":"CostToStudy_cost-to-study-container__4yufS","cost-card":"CostToStudy_cost-card__q3iiZ","cost-card-title":"CostToStudy_cost-card-title__f4hu5","cost-card-description":"CostToStudy_cost-card-description__Vx83d","cost-card-features":"CostToStudy_cost-card-features__jxFiI","tab-container":"CostToStudy_tab-container__9r_RS","active-tab":"CostToStudy_active-tab__jMIrA","cards-container":"CostToStudy_cards-container__D6CeK","card":"CostToStudy_card__FKjAA","card-icon":"CostToStudy_card-icon__AY88D","card-content":"CostToStudy_card-content__kAXqM","card-title":"CostToStudy_card-title__ySnP6","card-desc":"CostToStudy_card-desc__EoCy4","card-fees":"CostToStudy_card-fees__0Kl9F","card-currency-info":"CostToStudy_card-currency-info__ijV64"};

/***/ }),

/***/ 51147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"CountryDetail_hide-scrollbar__QYOXz","country-detail-container":"CountryDetail_country-detail-container__ltA_p","page-body":"CountryDetail_page-body__9WIeQ","section-with-padding":"CountryDetail_section-with-padding__xjv1L"};

/***/ }),

/***/ 72211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Courses_hide-scrollbar__1Stpi","courses-container":"Courses_courses-container__Pbipm","courses-title":"Courses_courses-title__azkyl","courses-description":"Courses_courses-description__5EJWs","section-btn-container":"Courses_section-btn-container__sEK_u","masters-btn":"Courses_masters-btn__wxn4s","bachelors-btn":"Courses_bachelors-btn__QrC4B","active-btn":"Courses_active-btn__uCK8S","btn-disabled":"Courses_btn-disabled__CbmQX","courses-card-container":"Courses_courses-card-container__sqqAn","courses-card-container-mobile":"Courses_courses-card-container-mobile__Vgu_P","viewport":"Courses_viewport__GAtN_","courses-card-slider-container":"Courses_courses-card-slider-container__A2UMG","courseSlide":"Courses_courseSlide__LVqyl","courseGrid":"Courses_courseGrid__lPo3H","courseCard":"Courses_courseCard__bQkv_","btcircle":"Courses_btcircle__t2XDz","arrows-container":"Courses_arrows-container__BnAVh","btcircle-disabled":"Courses_btcircle-disabled__lAlhA"};

/***/ }),

/***/ 14033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Elligibility_hide-scrollbar__6NBmC","elligibility-container":"Elligibility_elligibility-container__GTelq","elligibility-card":"Elligibility_elligibility-card__C6P21","elligibility-title":"Elligibility_elligibility-title__nWM6N","elligibility-description":"Elligibility_elligibility-description__T8shK","sub-card-container":"Elligibility_sub-card-container___cQdK","tab-container":"Elligibility_tab-container__PB_7C","tab-button":"Elligibility_tab-button__eMSKU","active-tab":"Elligibility_active-tab__gqZJS","sub-card":"Elligibility_sub-card__ve7I8","sub-card-image":"Elligibility_sub-card-image__d2CKx","image-wrapper":"Elligibility_image-wrapper__oqqSS","sub-card-content":"Elligibility_sub-card-content__LFdyy","sub-card-content-item-title":"Elligibility_sub-card-content-item-title__HqhwR","sub-card-content-item":"Elligibility_sub-card-content-item__ST4Nh","sub-card-content-item-description":"Elligibility_sub-card-content-item-description__JDUfm"};

/***/ }),

/***/ 47442:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Exams_hide-scrollbar__Pe22f","exams-section":"Exams_exams-section__npw_9","exams-container":"Exams_exams-container__O1VOC","exams-heading":"Exams_exams-heading__nXyfA","exams-subtext":"Exams_exams-subtext__jqyj_","exams-grid":"Exams_exams-grid__rE4wM","exam-card":"Exams_exam-card__WYc3l","exam-card__image-wrapper":"Exams_exam-card__image-wrapper__nsWFN","exam-card__label":"Exams_exam-card__label__UgIWz"};

/***/ }),

/***/ 54874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FAQs_hide-scrollbar__bAvCF","faq-section":"FAQs_faq-section__8O_rw","faq-container":"FAQs_faq-container__wno9A","faq-heading":"FAQs_faq-heading__yau_3","faq-subtext":"FAQs_faq-subtext__XTq79"};

/***/ }),

/***/ 16182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HeroSection_hide-scrollbar__xTDhJ","hero-section-container":"HeroSection_hero-section-container__amyFg","picture-bridge":"HeroSection_picture-bridge__rd624","text-content-container":"HeroSection_text-content-container__5pv22","breadcrumb-custom":"HeroSection_breadcrumb-custom__iAed4","breadcrumb-item-1":"HeroSection_breadcrumb-item-1__7bLeL","breadcrumb-item-2":"HeroSection_breadcrumb-item-2__4hAKa","hero-section-title":"HeroSection_hero-section-title___AkBR"};

/***/ }),

/***/ 61910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Intake_hide-scrollbar__uUvpI","intake-container":"Intake_intake-container__LRIQO","intake-title":"Intake_intake-title__gwDvo","intake-description":"Intake_intake-description__a1Uu4","intake-cards-container":"Intake_intake-cards-container__fCtK7","intake-card":"Intake_intake-card__eNa67","intake-card-clickable":"Intake_intake-card-clickable__ZoSNj","intake-card-bg":"Intake_intake-card-bg__L_ntE","intake-card-content":"Intake_intake-card-content__BCBPg","intake-card-title":"Intake_intake-card-title__XYjmR","intake-card-description":"Intake_intake-card-description__2W3kN"};

/***/ }),

/***/ 18318:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Overview_hide-scrollbar__kIdiC","overview-section-container":"Overview_overview-section-container___FLSD","overview-title":"Overview_overview-title__F855Y","overview-desc":"Overview_overview-desc__o_ZlY","overview-cards-container":"Overview_overview-cards-container__2L0g_","bootstrap-card":"Overview_bootstrap-card__eWx5T","icon-container":"Overview_icon-container__CzVbM","card-info":"Overview_card-info__5hySR","overview-grid-layout":"Overview_overview-grid-layout__AJXpk","overview-mobile-slider":"Overview_overview-mobile-slider__INovj","arrows-container":"Overview_arrows-container__QfIBo","btcircle":"Overview_btcircle__fYu3i"};

/***/ }),

/***/ 32164:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"QuickReels_hide-scrollbar__rTw4_","quickreels-section":"QuickReels_quickreels-section__F8_W5","quickreels-container":"QuickReels_quickreels-container__f4VBT","heading":"QuickReels_heading__AQ3jW","subtext":"QuickReels_subtext__pBufU","carousel-wrapper":"QuickReels_carousel-wrapper__FxXSd","viewport":"QuickReels_viewport__zUAj9","slider-container":"QuickReels_slider-container__DFG2S","slide":"QuickReels_slide__mNkC5","reel-card":"QuickReels_reel-card__B7FdX","reel-placeholder":"QuickReels_reel-placeholder__UHV0V","reel-iframe":"QuickReels_reel-iframe__D9k97","play-overlay":"QuickReels_play-overlay___wFZH","play-button-wrapper":"QuickReels_play-button-wrapper__PVxnn","play-button":"QuickReels_play-button__tgeKC","arrows-container":"QuickReels_arrows-container__fE9fz","arrow-btn":"QuickReels_arrow-btn__ibmhw","arrow-btn-disabled":"QuickReels_arrow-btn-disabled__7wT24"};

/***/ }),

/***/ 90128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"RelatedLinks_hide-scrollbar__4IdJV","rl-section":"RelatedLinks_rl-section__G4MHP","rl-container":"RelatedLinks_rl-container__3jNRl","rl-heading":"RelatedLinks_rl-heading__4cy4X","rl-subtext":"RelatedLinks_rl-subtext__tv8eN","rl-carousel-wrap":"RelatedLinks_rl-carousel-wrap__EwOvO","rl-viewport":"RelatedLinks_rl-viewport__0LLFo","rl-slider":"RelatedLinks_rl-slider__r9_M4","rl-slide":"RelatedLinks_rl-slide__AL0Ov","rl-card":"RelatedLinks_rl-card__8o0dq","rl-thumbnail":"RelatedLinks_rl-thumbnail__OSE7I","rl-thumbnail-img":"RelatedLinks_rl-thumbnail-img__IN_kj","rl-title":"RelatedLinks_rl-title__3Jz_i","rl-arrow":"RelatedLinks_rl-arrow__8mvmk","rl-arrow-disabled":"RelatedLinks_rl-arrow-disabled__qyg0L","rl-arrows-below":"RelatedLinks_rl-arrows-below__C20k1","rl-arrows-container":"RelatedLinks_rl-arrows-container__njsyQ"};

/***/ }),

/***/ 12724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Scholarships_hide-scrollbar__5_HAm","scholarships-container":"Scholarships_scholarships-container__5Vx0j","scholarships-title":"Scholarships_scholarships-title__gayeG","scholarships-description":"Scholarships_scholarships-description__apI7v","view-more-scholarships-btn":"Scholarships_view-more-scholarships-btn__zo411","scholarships-cards-container":"Scholarships_scholarships-cards-container__awn9A","viewport":"Scholarships_viewport__pkwH8","scholarships-cards-slider-container":"Scholarships_scholarships-cards-slider-container__Lh9tW","slide":"Scholarships_slide__1ATnO","bootstrap-card":"Scholarships_bootstrap-card__GiBLo","bootstrap-card-mobile":"Scholarships_bootstrap-card-mobile___5Z28","cardImageWrap":"Scholarships_cardImageWrap__xc3JU","cardImage":"Scholarships_cardImage__VpeKE","card-content":"Scholarships_card-content__ObF3n","university-title":"Scholarships_university-title__5xVEV","scholarship-title":"Scholarships_scholarship-title__o1Atz","scholarship-type":"Scholarships_scholarship-type__8SekZ","scholarship-amount":"Scholarships_scholarship-amount__B7VfP","text-amount":"Scholarships_text-amount__xvdWU","scholarship-description":"Scholarships_scholarship-description__U5MMN","enquiry-btn":"Scholarships_enquiry-btn__SZvQ5","arrows-container":"Scholarships_arrows-container__fQW9m","btcircle":"Scholarships_btcircle__LWIBQ","btcircle-disabled":"Scholarships_btcircle-disabled__K4wl2"};

/***/ }),

/***/ 84957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"StudentVisa_hide-scrollbar__CqnkM","sv-section":"StudentVisa_sv-section__ckHri","sv-container":"StudentVisa_sv-container__qb7aS","sv-heading":"StudentVisa_sv-heading__Dew20","sv-subtext":"StudentVisa_sv-subtext__kGdkh","sv-stats":"StudentVisa_sv-stats__hSx9c","sv-stat-card":"StudentVisa_sv-stat-card__in_9v","sv-stat-card__value":"StudentVisa_sv-stat-card__value__rdqxZ","sv-stat-card__label":"StudentVisa_sv-stat-card__label___PrhI","sv-bottom":"StudentVisa_sv-bottom__m8Fbe","sv-docs":"StudentVisa_sv-docs__NVhkT","sv-docs__title":"StudentVisa_sv-docs__title__AQIcM","sv-docs__grid":"StudentVisa_sv-docs__grid__21d9y","sv-docs__item":"StudentVisa_sv-docs__item__1TfWl","sv-docs__item__icon":"StudentVisa_sv-docs__item__icon__4fH11","sv-docs__more":"StudentVisa_sv-docs__more__lMH2g","sv-cta":"StudentVisa_sv-cta__5630O","sv-cta__title":"StudentVisa_sv-cta__title__2qbZ8","sv-cta__actions":"StudentVisa_sv-cta__actions__HrvF0","sv-cta__button":"StudentVisa_sv-cta__button__tO9uU","sv-cta__desc":"StudentVisa_sv-cta__desc__42QQf"};

/***/ }),

/***/ 48205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Testimonials_hide-scrollbar__tE4oD","tm-section":"Testimonials_tm-section__SAbh8","tm-container":"Testimonials_tm-container__GgEYZ","tm-heading":"Testimonials_tm-heading__p9Q6Z","tm-subtext":"Testimonials_tm-subtext__5XZTQ","tm-carousel-wrap":"Testimonials_tm-carousel-wrap__fUyV4","tm-viewport":"Testimonials_tm-viewport__4woFZ","tm-slider":"Testimonials_tm-slider__770gD","tm-slide":"Testimonials_tm-slide__R5YNa","tm-card":"Testimonials_tm-card__YhzZ8","tm-video-area":"Testimonials_tm-video-area__ZtAlN","tm-video":"Testimonials_tm-video__PzDlw","tm-quote-icon":"Testimonials_tm-quote-icon__RNPsv","play-button-wrapper":"Testimonials_play-button-wrapper__w4S6g","play-button":"Testimonials_play-button__zjQaE","tm-text-area":"Testimonials_tm-text-area__BuwNu","tm-name":"Testimonials_tm-name__lj0v5","tm-description":"Testimonials_tm-description__TOGQb","tm-arrow":"Testimonials_tm-arrow__dXRBl","tm-arrow-disabled":"Testimonials_tm-arrow-disabled__RHvyq","tm-arrows-below":"Testimonials_tm-arrows-below__3cwHx"};

/***/ }),

/***/ 66421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"TopAdmits_hide-scrollbar__x7sHZ","ta-section":"TopAdmits_ta-section__lEwW8","ta-container":"TopAdmits_ta-container__XANRY","ta-heading":"TopAdmits_ta-heading__lSOfr","ta-subtext":"TopAdmits_ta-subtext__ShlR_","ta-carousel-wrap":"TopAdmits_ta-carousel-wrap__EMXpj","ta-viewport":"TopAdmits_ta-viewport__Y9v0N","ta-slider":"TopAdmits_ta-slider__lmK6h","ta-slide":"TopAdmits_ta-slide__fEenp","ta-slide-inactive":"TopAdmits_ta-slide-inactive__pRZB6","ta-card":"TopAdmits_ta-card__itr6D","ta-avatar-wrap":"TopAdmits_ta-avatar-wrap__kUsCH","ta-avatar":"TopAdmits_ta-avatar__JxZ9j","ta-badge":"TopAdmits_ta-badge__6gsra","ta-name":"TopAdmits_ta-name__oRxwu","ta-university":"TopAdmits_ta-university__OMLEn","ta-intake":"TopAdmits_ta-intake__mngZn","ta-arrow":"TopAdmits_ta-arrow__Al8jn","ta-arrow-disabled":"TopAdmits_ta-arrow-disabled__cmOR7","ta-arrows-below":"TopAdmits_ta-arrows-below__xBfHr","ta-arrows-container":"TopAdmits_ta-arrows-container__j7FHU"};

/***/ }),

/***/ 58301:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"TopCities_hide-scrollbar__hApSj","tc-section":"TopCities_tc-section__sp1zt","tc-container":"TopCities_tc-container__q2z7K","tc-heading":"TopCities_tc-heading__p1Svg","tc-subtext":"TopCities_tc-subtext__4CzxF","tc-carousel-wrap":"TopCities_tc-carousel-wrap__SiqQw","tc-carousel-wrap--desktop":"TopCities_tc-carousel-wrap--desktop__nPz4n","tc-viewport":"TopCities_tc-viewport__CMCPF","tc-slider":"TopCities_tc-slider__VnavV","tc-slide":"TopCities_tc-slide__w3lfO","tc-pill":"TopCities_tc-pill__F7BlW","tc-pill--active":"TopCities_tc-pill--active__oaus5","tc-arrow":"TopCities_tc-arrow__7EC_c","tc-arrow-disabled":"TopCities_tc-arrow-disabled__AvGD7","tc-arrows-below":"TopCities_tc-arrows-below__VlPw0","tc-detail":"TopCities_tc-detail__RaNqh","tc-detail__info":"TopCities_tc-detail__info__7IOd_","tc-detail__heading":"TopCities_tc-detail__heading__TuuNY","tc-detail__desc":"TopCities_tc-detail__desc__6pjOp","tc-detail__uni-heading":"TopCities_tc-detail__uni-heading__PMSLz","tc-detail__uni-list":"TopCities_tc-detail__uni-list__iNFqG","loading-container":"TopCities_loading-container__gX5wy","tc-detail__uni-row":"TopCities_tc-detail__uni-row__59p8X","tc-detail__uni-row--clickable":"TopCities_tc-detail__uni-row--clickable__57Czh","tc-detail__uni-logo":"TopCities_tc-detail__uni-logo__RzgQP","tc-detail__uni-name":"TopCities_tc-detail__uni-name__hjcQM","tc-detail__uni-chevron":"TopCities_tc-detail__uni-chevron__j8yoQ","tc-detail__image":"TopCities_tc-detail__image__Hsb3v"};

/***/ }),

/***/ 49899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Universities_hide-scrollbar__eSi1r","universities-container":"Universities_universities-container__4tGLG","universities-title":"Universities_universities-title__fz4is","universities-description":"Universities_universities-description__KVVB5","uni-cards-container":"Universities_uni-cards-container__FlJJW","viewport":"Universities_viewport__eKRHo","uni-cards-slider-container":"Universities_uni-cards-slider-container__V6rRx","slide":"Universities_slide__X48qx","bootstrap-card":"Universities_bootstrap-card__esDBz","bootstrap-card-mobile":"Universities_bootstrap-card-mobile__7DgY5","cardImageWrap":"Universities_cardImageWrap__6OnQV","separator":"Universities_separator__yl1ad","card-content":"Universities_card-content__Q9gh1","address-text":"Universities_address-text__XBaKh","visit-website-link":"Universities_visit-website-link__MCSjz","card-btn-container":"Universities_card-btn-container__g3X52","know-more-btn":"Universities_know-more-btn__3pl8x","apply-now-btn":"Universities_apply-now-btn__7zdsI","arrows-container":"Universities_arrows-container__XYrlT","uni-cards-container-mobile":"Universities_uni-cards-container-mobile__2apRZ","view-more-universities-btn":"Universities_view-more-universities-btn__aXUQ0","btcircle":"Universities_btcircle__gn_jE","btcircle-disabled":"Universities_btcircle-disabled__U0rKy"};

/***/ }),

/***/ 69205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"WhyChooseKC_hide-scrollbar__1IA_O","wc-section":"WhyChooseKC_wc-section__3MFmN","wc-container":"WhyChooseKC_wc-container__xlvkH","wc-heading":"WhyChooseKC_wc-heading__gxNPc","wc-subtext":"WhyChooseKC_wc-subtext__ke0z_","wc-columns":"WhyChooseKC_wc-columns__Uq_Cm","wc-images":"WhyChooseKC_wc-images__94ved","wc-img-back":"WhyChooseKC_wc-img-back__MGvGD","wc-img-front":"WhyChooseKC_wc-img-front__hBauu","wc-accordion":"WhyChooseKC_wc-accordion__KhW6C"};

/***/ }),

/***/ 20829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Modal_hide-scrollbar__F_AwE","backdrop":"Modal_backdrop__LYeoI","modal-container":"Modal_modal-container__jCOB5","close-button-container":"Modal_close-button-container__YUpBu","close-button":"Modal_close-button__8DqXp"};

/***/ }),

/***/ 49273:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"SecondaryNav_hide-scrollbar__cIImW","secondaryNavContainer":"SecondaryNav_secondaryNavContainer__5wY3u","secondaryNavItem":"SecondaryNav_secondaryNavItem__ZC0Ai","secondaryNavItemActive":"SecondaryNav_secondaryNavItemActive__q9oIt","activeIndicator":"SecondaryNav_activeIndicator__CDDed","secondary-menu":"SecondaryNav_secondary-menu__k5XjX","secondary-menu-item":"SecondaryNav_secondary-menu-item__GovbT","modal-content":"SecondaryNav_modal-content__aQy9a","modal-content-item":"SecondaryNav_modal-content-item__CB8yI","modalContentItemActive":"SecondaryNav_modalContentItemActive__b4Vqh"};

/***/ }),

/***/ 28154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__gcxKa","spin":"Spinner_spin__p0RVb"};

/***/ }),

/***/ 42660:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"impoLinkImg":"countrypage_impoLinkImg__ZhxXn","abttopContent":"countrypage_abttopContent__OAePw","sectionBorder":"countrypage_sectionBorder__uKZAK","enquireBtn":"countrypage_enquireBtn__RTDdw","centerContent":"countrypage_centerContent__GIRdX","edtech":"countrypage_edtech__9wWYS","breadcrum":"countrypage_breadcrum__duRwt","enquirebtn":"countrypage_enquirebtn__0Qvpz","heading":"countrypage_heading__aLMx0","buttongp":"countrypage_buttongp__OF3jf","kcbtn":"countrypage_kcbtn__KKXxp","centered":"countrypage_centered__KeniP","breadcrumb-item":"countrypage_breadcrumb-item__LAA6G","active":"countrypage_active__lXg8H","hideimg":"countrypage_hideimg__Yan5R","rowPadding":"countrypage_rowPadding__LIHaj","viewMore":"countrypage_viewMore__nPENx","learnText":"countrypage_learnText__QBQMf","iconSetting":"countrypage_iconSetting__oKH6_","homePageLatestKcUpdates":"countrypage_homePageLatestKcUpdates__P_S8r","homePageBlogs":"countrypage_homePageBlogs___yBDI","countryPageBlog":"countrypage_countryPageBlog__yYACW","studyContent":"countrypage_studyContent__pG_IL","studyAnchor":"countrypage_studyAnchor__znYu5","h2title":"countrypage_h2title__uVAOi","indusContent":"countrypage_indusContent__ZJ2uF","imgRestructured":"countrypage_imgRestructured__FkJA2","picA":"countrypage_picA__md8Ri","picB":"countrypage_picB__qvktp","popularUniversities":"countrypage_popularUniversities__nN7W6","popularCourses":"countrypage_popularCourses__wAMJK","containerSpace":"countrypage_containerSpace__ksm7Z","popcourse":"countrypage_popcourse__Nu2HP","h2text":"countrypage_h2text__EHNYP","starimg":"countrypage_starimg__d59sX","morelink":"countrypage_morelink__4_Pe0","impoLinktext":"countrypage_impoLinktext__iL_yq","costofEducation":"countrypage_costofEducation__SIot8","recogTabs":"countrypage_recogTabs__Gii_C","headtr":"countrypage_headtr__LwMeq","headsmalltr":"countrypage_headsmalltr__qcyeU","customtr":"countrypage_customtr__G2N_S","studentTestSlider":"countrypage_studentTestSlider__lcoQB","imgContainer":"countrypage_imgContainer__FYsGE"};

/***/ }),

/***/ 82908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentServicesPage":"studentservices_studentServicesPage__jDBb9","studentServicesCurve":"studentservices_studentServicesCurve__V6eKt","contentDiv":"studentservices_contentDiv__wEbZf","enquirebtn":"studentservices_enquirebtn__ld5mL","servContent":"studentservices_servContent__PL5SN","WhyKc":"studentservices_WhyKc__sZxHm","viewMore":"studentservices_viewMore__bN0nA","img":"studentservices_img__H06y5","studentServicesWebinarEvent":"studentservices_studentServicesWebinarEvent__YR1_a","studentHelpMainDiv":"studentservices_studentHelpMainDiv__1GWsb","studentHelp":"studentservices_studentHelp__1fO7O","alignTop":"studentservices_alignTop__iMtE_","subAnchor":"studentservices_subAnchor__jRKHU","knowMore":"studentservices_knowMore__Y1q7q","linksDiv":"studentservices_linksDiv__KAP9F","studentServicesKcUpdates":"studentservices_studentServicesKcUpdates__LWcWL","StudentBlogs":"studentservices_StudentBlogs__TKFes","studentFooter":"studentservices_studentFooter__C7T7a","session":"studentservices_session__I15Qa","student":"studentservices_student__R_JgR","middelStuTest":"studentservices_middelStuTest__JJpvH","stuTestCard":"studentservices_stuTestCard__s_G5N","cardBody":"studentservices_cardBody__fAO4I","addre":"studentservices_addre__cGp__","studentTestSlider":"studentservices_studentTestSlider__bff6C","sevenBG":"studentservices_sevenBG__ovks8","sliderDots":"studentservices_sliderDots__PrfDo","slick-slide":"studentservices_slick-slide__Zwpji","slick-center":"studentservices_slick-center__42LQ5","arrowsClass":"studentservices_arrowsClass__pblWv","btcircle":"studentservices_btcircle__uDqgR","arrowsClasses":"studentservices_arrowsClasses__SQl3Q"};

/***/ }),

/***/ 75147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Table = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  striped,
  bordered,
  borderless,
  hover,
  size,
  variant,
  responsive,
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'table');
  const classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-striped`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);

  const table = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("table", { ...props,
    className: classes,
    ref: ref
  });

  if (responsive) {
    let responsiveClass = `${decoratedBsPrefix}-responsive`;

    if (typeof responsive === 'string') {
      responsiveClass = `${responsiveClass}-${responsive}`;
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: responsiveClass,
      children: table
    });
  }

  return table;
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);

/***/ }),

/***/ 85509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47150);
/* harmony import */ var _restart_ui_Tabs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83916);
/* harmony import */ var _Nav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80957);
/* harmony import */ var _NavLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14691);
/* harmony import */ var _NavItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41244);
/* harmony import */ var _TabContent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28752);
/* harmony import */ var _TabPane__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75103);
/* harmony import */ var _ElementChildren__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53439);
/* harmony import */ var _getTabTransitionComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96101);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);












const defaultProps = {
  variant: 'tabs',
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  let defaultActiveKey;
  (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .forEach */ .Ed)(children, child => {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

function renderTab(child) {
  const {
    title,
    eventKey,
    disabled,
    tabClassName,
    tabAttrs,
    id
  } = child.props;

  if (title == null) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_NavItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    as: "li",
    role: "presentation",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_NavLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      as: "button",
      type: "button",
      eventKey: eventKey,
      disabled: disabled,
      id: id,
      className: tabClassName,
      ...tabAttrs,
      children: title
    })
  });
}

const Tabs = props => {
  const {
    id,
    onSelect,
    transition,
    mountOnEnter,
    unmountOnExit,
    children,
    activeKey = getDefaultActiveKey(children),
    ...controlledProps
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_1__/* .useUncontrolled */ .Ch)(props, {
    activeKey: 'onSelect'
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_restart_ui_Tabs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: (0,_getTabTransitionComponent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(transition),
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { ...controlledProps,
      role: "tablist",
      as: "ul",
      children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(children, renderTab)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TabContent__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(children, child => {
        const childProps = { ...child.props
        };
        delete childProps.title;
        delete childProps.disabled;
        delete childProps.tabClassName;
        delete childProps.tabAttrs;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TabPane__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { ...childProps
        });
      })
    })]
  });
};

Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';
/* harmony default export */ __webpack_exports__["Z"] = (Tabs);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,4706,9382,474,5684,9465,3593,133,9774,2888,179], function() { return __webpack_exec__(36151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);